webpackJsonp([35783957827783],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.5 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.9 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _d3Timer = __webpack_require__(113);
	
	var _utils = __webpack_require__(115);
	
	var _Events = _interopRequireDefault(__webpack_require__(213));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var BaseNode = function () {
	  function BaseNode(state) {
	    _classCallCheck(this, BaseNode);
	
	    this.state = state || {};
	  }
	
	  _createClass(BaseNode, [{
	    key: "transition",
	    value: function transition(config) {
	      if (Array.isArray(config)) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = config[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	            this.parse(item);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else {
	        this.parse(config);
	      }
	    }
	  }, {
	    key: "isTransitioning",
	    value: function isTransitioning() {
	      return !!this.transitionData;
	    }
	  }, {
	    key: "stopTransitions",
	    value: function stopTransitions() {
	      var transitions = this.transitionData;
	
	      if (transitions) {
	        Object.keys(transitions).forEach(function (t) {
	          transitions[t].timer.stop();
	        });
	      }
	    }
	  }, {
	    key: "setState",
	    value: function setState(update) {
	      if (typeof update === 'function') {
	        (0, _utils.extend)(this.state, update(this.state));
	      } else {
	        (0, _utils.extend)(this.state, update);
	      }
	    }
	  }, {
	    key: "parse",
	    value: function parse(config) {
	      var _this = this;
	
	      var clone = _objectSpread({}, config);
	
	      var events = new _Events.default(clone);
	
	      if (clone.events) {
	        delete clone.events;
	      }
	
	      var timing = _objectSpread({}, _utils.timingDefaults, clone.timing || {}, {
	        time: (0, _d3Timer.now)()
	      });
	
	      if (clone.timing) {
	        delete clone.timing;
	      }
	
	      Object.keys(clone).forEach(function (stateKey) {
	        var tweens = [];
	        var next = clone[stateKey];
	
	        if ((0, _utils.isNamespace)(next)) {
	          Object.keys(next).forEach(function (attr) {
	            var val = next[attr];
	
	            if (Array.isArray(val)) {
	              if (val.length === 1) {
	                tweens.push(_this.getTween(attr, val[0], stateKey));
	              } else {
	                _this.setState(function (state) {
	                  var _objectSpread2, _ref;
	
	                  return _ref = {}, _ref[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread2 = {}, _objectSpread2[attr] = val[0], _objectSpread2)), _ref;
	                });
	
	                tweens.push(_this.getTween(attr, val[1], stateKey));
	              }
	            } else if (typeof val === 'function') {
	              var getNameSpacedCustomTween = function getNameSpacedCustomTween() {
	                var kapellmeisterNamespacedTween = function kapellmeisterNamespacedTween(t) {
	                  _this.setState(function (state) {
	                    var _objectSpread3, _ref2;
	
	                    return _ref2 = {}, _ref2[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread3 = {}, _objectSpread3[attr] = val(t), _objectSpread3)), _ref2;
	                  });
	                };
	
	                return kapellmeisterNamespacedTween;
	              };
	
	              tweens.push(getNameSpacedCustomTween);
	            } else {
	              _this.setState(function (state) {
	                var _objectSpread4, _ref3;
	
	                return _ref3 = {}, _ref3[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread4 = {}, _objectSpread4[attr] = val, _objectSpread4)), _ref3;
	              });
	
	              tweens.push(_this.getTween(attr, val, stateKey));
	            }
	          });
	        } else {
	          if (Array.isArray(next)) {
	            if (next.length === 1) {
	              tweens.push(_this.getTween(stateKey, next[0], null));
	            } else {
	              var _this$setState;
	
	              _this.setState((_this$setState = {}, _this$setState[stateKey] = next[0], _this$setState));
	
	              tweens.push(_this.getTween(stateKey, next[1], null));
	            }
	          } else if (typeof next === 'function') {
	            var getCustomTween = function getCustomTween() {
	              var kapellmeisterTween = function kapellmeisterTween(t) {
	                var _this$setState2;
	
	                _this.setState((_this$setState2 = {}, _this$setState2[stateKey] = next(t), _this$setState2));
	              };
	
	              return kapellmeisterTween;
	            };
	
	            tweens.push(getCustomTween);
	          } else {
	            var _this$setState3;
	
	            _this.setState((_this$setState3 = {}, _this$setState3[stateKey] = next, _this$setState3));
	
	            tweens.push(_this.getTween(stateKey, next, null));
	          }
	        }
	
	        _this.update({
	          stateKey: stateKey,
	          timing: timing,
	          tweens: tweens,
	          events: events,
	          status: 0
	        });
	      });
	    }
	  }, {
	    key: "getTween",
	    value: function getTween(attr, endValue, nameSpace) {
	      var _this2 = this;
	
	      return function () {
	        var begValue = nameSpace ? _this2.state[nameSpace][attr] : _this2.state[attr];
	
	        if (begValue === endValue) {
	          return null;
	        }
	
	        var i = _this2.getInterpolator(begValue, endValue, attr, nameSpace);
	
	        var stateTween;
	
	        if (nameSpace === null) {
	          stateTween = function stateTween(t) {
	            var _this2$setState;
	
	            _this2.setState((_this2$setState = {}, _this2$setState[attr] = i(t), _this2$setState));
	          };
	        } else {
	          stateTween = function stateTween(t) {
	            _this2.setState(function (state) {
	              var _objectSpread5, _ref4;
	
	              return _ref4 = {}, _ref4[nameSpace] = _objectSpread({}, state[nameSpace], (_objectSpread5 = {}, _objectSpread5[attr] = i(t), _objectSpread5)), _ref4;
	            });
	          };
	        }
	
	        return stateTween;
	      };
	    }
	  }, {
	    key: "update",
	    value: function update(transition) {
	      if (!this.transitionData) {
	        this.transitionData = {};
	      }
	
	      this.init((0, _utils.getTransitionId)(), transition);
	    }
	  }, {
	    key: "init",
	    value: function init(id, transition) {
	      var _this3 = this;
	
	      var n = transition.tweens.length;
	      var tweens = new Array(n);
	
	      var queue = function queue(elapsed) {
	        transition.status = 1;
	        transition.timer.restart(start, transition.timing.delay, transition.timing.time);
	
	        if (transition.timing.delay <= elapsed) {
	          start(elapsed - transition.timing.delay);
	        }
	      };
	
	      this.transitionData[id] = transition;
	      transition.timer = (0, _d3Timer.timer)(queue, 0, transition.timing.time);
	
	      var start = function start(elapsed) {
	        if (transition.status !== 1) return stop();
	
	        for (var tid in _this3.transitionData) {
	          var t = _this3.transitionData[tid];
	
	          if (t.stateKey !== transition.stateKey) {
	            continue;
	          }
	
	          if (t.status === 3) {
	            return (0, _d3Timer.timeout)(start);
	          }
	
	          if (t.status === 4) {
	            t.status = 6;
	            t.timer.stop();
	
	            if (t.events.interrupt) {
	              t.events.interrupt.call(_this3);
	            }
	
	            delete _this3.transitionData[tid];
	          } else if (+tid < id) {
	            t.status = 6;
	            t.timer.stop();
	            delete _this3.transitionData[tid];
	          }
	        }
	
	        (0, _d3Timer.timeout)(function () {
	          if (transition.status === 3) {
	            transition.status = 4;
	            transition.timer.restart(tick, transition.timing.delay, transition.timing.time);
	            tick(elapsed);
	          }
	        });
	        transition.status = 2;
	
	        if (transition.events.start) {
	          transition.events.start.call(_this3);
	        }
	
	        if (transition.status !== 2) {
	          return;
	        }
	
	        transition.status = 3;
	        var j = -1;
	
	        for (var i = 0; i < n; ++i) {
	          var res = transition.tweens[i]();
	
	          if (res) {
	            tweens[++j] = res;
	          }
	        }
	
	        tweens.length = j + 1;
	      };
	
	      var tick = function tick(elapsed) {
	        var t = 1;
	
	        if (elapsed < transition.timing.duration) {
	          t = transition.timing.ease(elapsed / transition.timing.duration);
	        } else {
	          transition.timer.restart(stop);
	          transition.status = 5;
	        }
	
	        var i = -1;
	
	        while (++i < tweens.length) {
	          tweens[i](t);
	        }
	
	        if (transition.status === 5) {
	          if (transition.events.end) {
	            transition.events.end.call(_this3);
	          }
	
	          stop();
	        }
	      };
	
	      var stop = function stop() {
	        transition.status = 6;
	        transition.timer.stop();
	        delete _this3.transitionData[id];
	
	        for (var _ in _this3.transitionData) {
	          return;
	        }
	
	        delete _this3.transitionData;
	      };
	    }
	  }]);
	
	  return BaseNode;
	}();
	
	var _default = BaseNode;
	exports.default = _default;

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Events = void 0;
	
	var _utils = __webpack_require__(115);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Events = function Events(config) {
	  var _this = this;
	
	  _classCallCheck(this, Events);
	
	  this.start = null;
	  this.interrupt = null;
	  this.end = null;
	
	  if (config.events) {
	    Object.keys(config.events).forEach(function (d) {
	      if (typeof config.events[d] !== 'function') {
	        throw new Error('Event handlers must be a function');
	      } else {
	        _this[d] = (0, _utils.once)(config.events[d]);
	      }
	    });
	  }
	};
	
	exports.Events = Events;
	var _default = Events;
	exports.default = _default;

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "BaseNode", {
	  enumerable: true,
	  get: function get() {
	    return _BaseNode.default;
	  }
	});
	Object.defineProperty(exports, "now", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.now;
	  }
	});
	Object.defineProperty(exports, "timer", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.timer;
	  }
	});
	Object.defineProperty(exports, "interval", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.interval;
	  }
	});
	Object.defineProperty(exports, "timeout", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.timeout;
	  }
	});
	
	var _BaseNode = _interopRequireDefault(__webpack_require__(212));
	
	var _d3Timer = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionId = getTransitionId;
	exports.extend = extend;
	exports.once = once;
	exports.isNamespace = isNamespace;
	exports.timingDefaults = void 0;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var transitionId = 0;
	
	function getTransitionId() {
	  return ++transitionId;
	}
	
	function extend(obj, props) {
	  for (var i in props) {
	    obj[i] = props[i];
	  }
	}
	
	function once(func) {
	  var called = false;
	  return function transitionEvent() {
	    if (!called) {
	      called = true;
	      func.call(this);
	    }
	  };
	}
	
	function isNamespace(prop) {
	  return _typeof(prop) === 'object' && Array.isArray(prop) === false;
	}
	
	var linear = function linear(t) {
	  return +t;
	};
	
	var timingDefaults = {
	  delay: 0,
	  duration: 250,
	  ease: linear
	};
	exports.timingDefaults = timingDefaults;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(218).default;
	module.exports.default = module.exports;


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _scrollTransition = _interopRequireDefault(__webpack_require__(221));
	
	var _fadeTransition = _interopRequireDefault(__webpack_require__(220));
	
	var _dScrollTransition = _interopRequireDefault(__webpack_require__(219));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  fade: _fadeTransition["default"],
	  scroll: _scrollTransition["default"],
	  scroll3d: _dScrollTransition["default"]
	};
	exports["default"] = _default;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.defaultRenderAnnounceSlideMessage = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var AnnounceSlide = function AnnounceSlide(_ref) {
	  var message = _ref.message;
	  var styles = {
	    position: 'absolute',
	    left: '-10000px',
	    top: 'auto',
	    width: '1px',
	    height: '1px',
	    overflow: 'hidden'
	  };
	  return _react["default"].createElement("div", {
	    "aria-live": "polite",
	    "aria-atomic": "true",
	    style: styles,
	    tabIndex: -1
	  }, message);
	};
	
	var defaultRenderAnnounceSlideMessage = function defaultRenderAnnounceSlideMessage(_ref2) {
	  var currentSlide = _ref2.currentSlide,
	      slideCount = _ref2.slideCount;
	  return "Slide ".concat(currentSlide + 1, " of ").concat(slideCount);
	};
	
	exports.defaultRenderAnnounceSlideMessage = defaultRenderAnnounceSlideMessage;
	var _default = AnnounceSlide;
	exports["default"] = _default;

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PagingDots = exports.NextButton = exports.PreviousButton = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultButtonStyles = function defaultButtonStyles(disabled) {
	  return {
	    border: 0,
	    background: 'rgba(0,0,0,0.4)',
	    color: 'white',
	    padding: 10,
	    opacity: disabled ? 0.3 : 1,
	    cursor: disabled ? 'not-allowed' : 'pointer'
	  };
	};
	
	var PreviousButton =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(PreviousButton, _React$Component);
	
	  function PreviousButton() {
	    var _this;
	
	    _classCallCheck(this, PreviousButton);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreviousButton).apply(this, arguments));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(PreviousButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.previousSlide();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var disabled = this.props.currentSlide === 0 && !this.props.wrapAround || this.props.slideCount === 0;
	      return _react["default"].createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "previous"
	      }, "PREV");
	    }
	  }]);
	
	  return PreviousButton;
	}(_react["default"].Component);
	
	exports.PreviousButton = PreviousButton;
	
	var NextButton =
	/*#__PURE__*/
	function (_React$Component2) {
	  _inherits(NextButton, _React$Component2);
	
	  function NextButton() {
	    var _this2;
	
	    _classCallCheck(this, NextButton);
	
	    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(NextButton).apply(this, arguments));
	    _this2.handleClick = _this2.handleClick.bind(_assertThisInitialized(_this2));
	    _this2.nextButtonDisable = _this2.nextButtonDisabled.bind(_assertThisInitialized(_this2));
	    return _this2;
	  }
	
	  _createClass(NextButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.nextSlide();
	    }
	  }, {
	    key: "nextButtonDisabled",
	    value: function nextButtonDisabled(params) {
	      var wrapAround = params.wrapAround,
	          slidesToShow = params.slidesToShow,
	          currentSlide = params.currentSlide,
	          cellAlign = params.cellAlign,
	          slideCount = params.slideCount;
	      var buttonDisabled = false;
	
	      if (!wrapAround) {
	        var lastSlideIndex = slideCount - 1;
	        var slidesShowing = slidesToShow;
	        var lastSlideOffset = 0;
	
	        switch (cellAlign) {
	          case 'center':
	            slidesShowing = (slidesToShow - 1) * 0.5;
	            lastSlideOffset = Math.floor(slidesToShow * 0.5) - 1;
	            break;
	
	          case 'right':
	            slidesShowing = 1;
	            break;
	        }
	
	        if (slidesToShow > 1) {
	          buttonDisabled = currentSlide + slidesShowing > lastSlideIndex + lastSlideOffset;
	        } else {
	          buttonDisabled = currentSlide + 1 > lastSlideIndex;
	        }
	      }
	
	      return buttonDisabled;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          wrapAround = _this$props.wrapAround,
	          slidesToShow = _this$props.slidesToShow,
	          currentSlide = _this$props.currentSlide,
	          cellAlign = _this$props.cellAlign,
	          slideCount = _this$props.slideCount;
	      var disabled = this.nextButtonDisabled({
	        wrapAround: wrapAround,
	        slidesToShow: slidesToShow,
	        currentSlide: currentSlide,
	        cellAlign: cellAlign,
	        slideCount: slideCount
	      });
	      return _react["default"].createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "next"
	      }, "NEXT");
	    }
	  }]);
	
	  return NextButton;
	}(_react["default"].Component);
	
	exports.NextButton = NextButton;
	
	var PagingDots =
	/*#__PURE__*/
	function (_React$Component3) {
	  _inherits(PagingDots, _React$Component3);
	
	  function PagingDots() {
	    _classCallCheck(this, PagingDots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PagingDots).apply(this, arguments));
	  }
	
	  _createClass(PagingDots, [{
	    key: "getDotIndexes",
	    value: function getDotIndexes(slideCount, slidesToScroll, slidesToShow, cellAlign) {
	      var dotIndexes = [];
	      var lastDotIndex = slideCount - slidesToShow;
	
	      switch (cellAlign) {
	        case 'center':
	        case 'right':
	          lastDotIndex += slidesToShow - 1;
	          break;
	      }
	
	      if (lastDotIndex < 0) {
	        return [0];
	      }
	
	      for (var i = 0; i < lastDotIndex; i += slidesToScroll) {
	        dotIndexes.push(i);
	      }
	
	      dotIndexes.push(lastDotIndex);
	      return dotIndexes;
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles() {
	      return {
	        position: 'relative',
	        margin: 0,
	        top: -10,
	        padding: 0
	      };
	    }
	  }, {
	    key: "getListItemStyles",
	    value: function getListItemStyles() {
	      return {
	        listStyleType: 'none',
	        display: 'inline-block'
	      };
	    }
	  }, {
	    key: "getButtonStyles",
	    value: function getButtonStyles(active) {
	      return {
	        cursor: 'pointer',
	        opacity: active ? 1 : 0.5,
	        background: 'transparent',
	        border: 'none'
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var indexes = this.getDotIndexes(this.props.slideCount, this.props.slidesToScroll, this.props.slidesToShow, this.props.cellAlign);
	      return _react["default"].createElement("ul", {
	        style: this.getListStyles()
	      }, indexes.map(function (index) {
	        return _react["default"].createElement("li", {
	          style: _this3.getListItemStyles(),
	          key: index,
	          className: _this3.props.currentSlide === index ? 'paging-item active' : 'paging-item'
	        }, _react["default"].createElement("button", {
	          style: _this3.getButtonStyles(_this3.props.currentSlide === index),
	          onClick: _this3.props.goToSlide.bind(null, index),
	          "aria-label": "slide ".concat(index + 1, " bullet")
	        }, _react["default"].createElement("span", {
	          className: "paging-dot",
	          style: {
	            display: 'inline-block',
	            borderRadius: '50%',
	            width: '6px',
	            height: '6px',
	            background: 'black'
	          }
	        })));
	      }));
	    }
	  }]);
	
	  return PagingDots;
	}(_react["default"].Component);
	
	exports.PagingDots = PagingDots;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "PagingDots", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PagingDots;
	  }
	});
	Object.defineProperty(exports, "PreviousButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PreviousButton;
	  }
	});
	Object.defineProperty(exports, "NextButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.NextButton;
	  }
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _exenv = _interopRequireDefault(__webpack_require__(202));
	
	var _Animate = _interopRequireDefault(__webpack_require__(243));
	
	var easing = _interopRequireWildcard(__webpack_require__(200));
	
	var _defaultControls = __webpack_require__(217);
	
	var _allTransitions = _interopRequireDefault(__webpack_require__(215));
	
	var _announceSlide = _interopRequireWildcard(__webpack_require__(216));
	
	var _utilities = __webpack_require__(224);
	
	var _styleUtilities = __webpack_require__(223);
	
	var _bootstrappingUtilities = __webpack_require__(222);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  function Carousel() {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).apply(this, arguments));
	    _this.displayName = 'Carousel';
	    _this.clickDisabled = false;
	    _this.isTransitioning = false;
	    _this.touchObject = {};
	    _this.controlsMap = [{
	      funcName: 'renderTopLeftControls',
	      key: 'TopLeft'
	    }, {
	      funcName: 'renderTopCenterControls',
	      key: 'TopCenter'
	    }, {
	      funcName: 'renderTopRightControls',
	      key: 'TopRight'
	    }, {
	      funcName: 'renderCenterLeftControls',
	      key: 'CenterLeft'
	    }, {
	      funcName: 'renderCenterCenterControls',
	      key: 'CenterCenter'
	    }, {
	      funcName: 'renderCenterRightControls',
	      key: 'CenterRight'
	    }, {
	      funcName: 'renderBottomLeftControls',
	      key: 'BottomLeft'
	    }, {
	      funcName: 'renderBottomCenterControls',
	      key: 'BottomCenter'
	    }, {
	      funcName: 'renderBottomRightControls',
	      key: 'BottomRight'
	    }];
	    _this.childNodesMutationObs = null;
	    _this.state = _objectSpread({
	      currentSlide: _this.props.slideIndex,
	      dragging: false,
	      easing: _this.props.disableAnimation ? '' : easing.easeCircleOut,
	      hasInteraction: false,
	      // to remove animation from the initial slide on the page load when non-default slideIndex is used
	      isWrappingAround: false,
	      left: 0,
	      resetWrapAroundPosition: false,
	      slideCount: (0, _bootstrappingUtilities.getValidChildren)(_this.props.children).length,
	      top: 0,
	      wrapToIndex: null
	    }, (0, _utilities.calcSomeInitialState)(_this.props));
	    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized(_this));
	    _this.calcSlideHeightAndWidth = _this.calcSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized(_this));
	    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized(_this));
	    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized(_this));
	    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized(_this));
	    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized(_this));
	    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized(_this));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
	    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
	    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
	    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized(_this));
	    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
	    _this.onReadyStateChange = _this.onReadyStateChange.bind(_assertThisInitialized(_this));
	    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
	    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized(_this));
	    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized(_this));
	    _this.renderControls = _this.renderControls.bind(_assertThisInitialized(_this));
	    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized(_this));
	    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
	    _this.setLeft = _this.setLeft.bind(_assertThisInitialized(_this));
	    _this.setSlideHeightAndWidth = _this.setSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized(_this));
	    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized(_this));
	    _this.establishChildNodesMutationObserver = _this.establishChildNodesMutationObserver.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	      this.mounted = true;
	      this.setLeft();
	      this.setDimensions();
	      this.bindEvents();
	      this.establishChildNodesMutationObserver();
	
	      if (this.props.autoplay) {
	        this.startAutoplay();
	      }
	    } // @TODO Remove deprecated componentWillReceiveProps with getDerivedStateFromProps
	    // eslint-disable-next-line react/no-deprecated
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var slideCount = (0, _bootstrappingUtilities.getValidChildren)(nextProps.children).length;
	      var slideCountChanged = slideCount !== this.state.slideCount;
	      this.setState(function (prevState) {
	        return {
	          slideCount: slideCount,
	          currentSlide: slideCountChanged ? nextProps.slideIndex : prevState.currentSlide
	        };
	      });
	
	      if (slideCount <= this.state.currentSlide) {
	        this.goToSlide(Math.max(slideCount - 1, 0), nextProps);
	      }
	
	      var updateDimensions = slideCountChanged || (0, _utilities.shouldUpdate)(this.props, nextProps, ['cellSpacing', 'vertical', 'slideWidth', 'slideHeight', 'heightMode', 'slidesToScroll', 'slidesToShow', 'transitionMode', 'cellAlign']);
	
	      if (updateDimensions) {
	        this.setDimensions(nextProps);
	      }
	
	      if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
	        this.goToSlide(nextProps.slideIndex, this.props);
	      }
	
	      if (this.props.autoplay !== nextProps.autoplay) {
	        if (nextProps.autoplay) {
	          this.startAutoplay();
	        } else {
	          this.stopAutoplay();
	        }
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var slideChanged = prevState.currentSlide !== this.state.currentSlide;
	      var heightModeChanged = prevProps.heightMode !== this.props.heightMode;
	      var axisChanged = prevProps.vertical !== this.props.vertical;
	
	      if (axisChanged) {
	        this.onResize();
	      } else if (slideChanged || heightModeChanged) {
	        this.setSlideHeightAndWidth();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unbindEvents();
	      this.disconnectChildNodesMutationObserver();
	      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	
	      this.mounted = false;
	    }
	  }, {
	    key: "establishChildNodesMutationObserver",
	    value: function establishChildNodesMutationObserver() {
	      var _this2 = this;
	
	      var childNodes = this.getChildNodes();
	
	      if (childNodes.length && 'MutationObserver' in window) {
	        this.childNodesMutationObs = new MutationObserver(function (mutations) {
	          mutations.forEach(function () {
	            _this2.setSlideHeightAndWidth();
	          });
	        });
	
	        var observeChildNodeMutation = function observeChildNodeMutation(node) {
	          _this2.childNodesMutationObs.observe(node, {
	            attributes: true,
	            attributeFilter: ['style'],
	            attributeOldValue: false,
	            characterData: false,
	            characterDataOldValue: false,
	            childList: false,
	            subtree: false
	          });
	        };
	
	        var childNodesArray = Array.from(childNodes);
	
	        for (var _i = 0, _childNodesArray = childNodesArray; _i < _childNodesArray.length; _i++) {
	          var node = _childNodesArray[_i];
	          observeChildNodeMutation(node);
	        }
	      }
	    }
	  }, {
	    key: "disconnectChildNodesMutationObserver",
	    value: function disconnectChildNodesMutationObserver() {
	      if (this.childNodesMutationObs instanceof MutationObserver) {
	        this.childNodesMutationObs.disconnect();
	      }
	    }
	  }, {
	    key: "getTouchEvents",
	    value: function getTouchEvents() {
	      var _this3 = this;
	
	      if (this.props.swiping === false) {
	        return {
	          onTouchStart: this.handleMouseOver,
	          onTouchEnd: this.handleMouseOut
	        };
	      }
	
	      return {
	        onTouchStart: function onTouchStart(e) {
	          _this3.touchObject = {
	            startX: e.touches[0].pageX,
	            startY: e.touches[0].pageY
	          };
	
	          _this3.handleMouseOver();
	
	          _this3.setState({
	            dragging: true
	          });
	        },
	        onTouchMove: function onTouchMove(e) {
	          var direction = (0, _utilities.swipeDirection)(_this3.touchObject.startX, e.touches[0].pageX, _this3.touchObject.startY, e.touches[0].pageY, _this3.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this3.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this3.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this3.touchObject.startX, 2)));
	          _this3.touchObject = {
	            startX: _this3.touchObject.startX,
	            startY: _this3.touchObject.startY,
	            endX: e.touches[0].pageX,
	            endY: e.touches[0].pageY,
	            length: length,
	            direction: direction
	          };
	
	          _this3.setState({
	            left: _this3.props.vertical ? 0 : _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction),
	            top: _this3.props.vertical ? _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction) : 0
	          });
	        },
	        onTouchEnd: function onTouchEnd(e) {
	          _this3.handleSwipe(e);
	
	          _this3.handleMouseOut();
	        },
	        onTouchCancel: function onTouchCancel(e) {
	          _this3.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "getMouseEvents",
	    value: function getMouseEvents() {
	      var _this4 = this;
	
	      if (this.props.dragging === false) {
	        return {
	          onMouseOver: this.handleMouseOver,
	          onMouseOut: this.handleMouseOut
	        };
	      }
	
	      return {
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut,
	        onMouseDown: function onMouseDown(e) {
	          _this4.touchObject = {
	            startX: e.clientX,
	            startY: e.clientY
	          };
	
	          _this4.setState({
	            dragging: true
	          });
	        },
	        onMouseMove: function onMouseMove(e) {
	          if (!_this4.state.dragging) {
	            return;
	          }
	
	          var direction = (0, _utilities.swipeDirection)(_this4.touchObject.startX, e.clientX, _this4.touchObject.startY, e.clientY, _this4.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this4.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this4.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this4.touchObject.startX, 2))); // prevents disabling click just because mouse moves a fraction of a pixel
	
	          if (length >= 10) _this4.clickDisabled = true;
	          _this4.touchObject = {
	            startX: _this4.touchObject.startX,
	            startY: _this4.touchObject.startY,
	            endX: e.clientX,
	            endY: e.clientY,
	            length: length,
	            direction: direction
	          };
	
	          _this4.setState({
	            left: _this4.props.vertical ? 0 : _this4.getTargetLeft(_this4.touchObject.length * _this4.touchObject.direction),
	            top: _this4.props.vertical ? _this4.getTargetLeft(_this4.touchObject.length * _this4.touchObject.direction) : 0
	          });
	        },
	        onMouseUp: function onMouseUp(e) {
	          if (_this4.touchObject.length === 0 || _this4.touchObject.length === undefined) {
	            _this4.setState({
	              dragging: false
	            });
	
	            return;
	          }
	
	          _this4.handleSwipe(e);
	        },
	        onMouseLeave: function onMouseLeave(e) {
	          if (!_this4.state.dragging) {
	            return;
	          }
	
	          _this4.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "pauseAutoplay",
	    value: function pauseAutoplay() {
	      if (this.props.autoplay) {
	        this.autoplayPaused = true;
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "unpauseAutoplay",
	    value: function unpauseAutoplay() {
	      if (this.props.autoplay && this.autoplayPaused) {
	        this.startAutoplay();
	        this.autoplayPaused = null;
	      }
	    }
	  }, {
	    key: "handleMouseOver",
	    value: function handleMouseOver() {
	      if (this.props.pauseOnHover) {
	        this.pauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleMouseOut",
	    value: function handleMouseOut() {
	      if (this.autoplayPaused) {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      if (this.clickDisabled === true) {
	        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey) {
	          return;
	        }
	
	        event.preventDefault();
	        event.stopPropagation();
	
	        if (event.nativeEvent) {
	          event.nativeEvent.stopPropagation();
	        }
	      }
	    }
	  }, {
	    key: "handleSwipe",
	    value: function handleSwipe() {
	      var _this5 = this;
	
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
	        if (this.touchObject.direction === 1) {
	          if (this.state.currentSlide >= this.state.slideCount - slidesToShow && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.nextSlide();
	          }
	        } else if (this.touchObject.direction === -1) {
	          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.previousSlide();
	          }
	        }
	      } else {
	        this.goToSlide(this.state.currentSlide);
	      } // wait for `handleClick` event before resetting clickDisabled
	
	
	      setTimeout(function () {
	        _this5.clickDisabled = false;
	      }, 0);
	      this.touchObject = {};
	      this.setState({
	        dragging: false
	      });
	    } // eslint-disable-next-line complexity
	
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      if (this.props.enableKeyboardControls) {
	        switch (e.keyCode) {
	          case 39:
	          case 68:
	          case 38:
	          case 87:
	            this.nextSlide();
	            break;
	
	          case 37:
	          case 65:
	          case 40:
	          case 83:
	            this.previousSlide();
	            break;
	
	          case 81:
	            this.goToSlide(0, this.props);
	            break;
	
	          case 69:
	            this.goToSlide(this.state.slideCount - 1, this.props);
	            break;
	
	          case 32:
	            if (this.state.pauseOnHover && this.props.autoplay) {
	              this.setState({
	                pauseOnHover: false
	              });
	              this.pauseAutoplay();
	              break;
	            } else {
	              this.setState({
	                pauseOnHover: true
	              });
	              this.unpauseAutoplay();
	              break;
	            }
	
	        }
	      }
	    }
	  }, {
	    key: "autoplayIterator",
	    value: function autoplayIterator() {
	      if (this.props.wrapAround) {
	        if (this.props.autoplayReverse) {
	          this.previousSlide();
	        } else {
	          this.nextSlide();
	        }
	
	        return;
	      }
	
	      if (this.props.autoplayReverse) {
	        if (this.state.currentSlide !== 0) {
	          this.previousSlide();
	        } else {
	          this.stopAutoplay();
	        }
	      } else if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
	        this.nextSlide();
	      } else {
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "startAutoplay",
	    value: function startAutoplay() {
	      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
	    }
	  }, {
	    key: "resetAutoplay",
	    value: function resetAutoplay() {
	      if (this.props.autoplay && !this.autoplayPaused) {
	        this.stopAutoplay();
	        this.startAutoplay();
	      }
	    }
	  }, {
	    key: "stopAutoplay",
	    value: function stopAutoplay() {
	      if (this.autoplayID) {
	        clearInterval(this.autoplayID);
	      }
	    } // Animation Method
	
	  }, {
	    key: "getTargetLeft",
	    value: function getTargetLeft(touchOffset, slide) {
	      var offset;
	      var target = slide || this.state.currentSlide;
	
	      switch (this.state.cellAlign) {
	        case 'left':
	          {
	            offset = 0;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'center':
	          {
	            offset = (this.state.frameWidth - this.state.slideWidth) / 2;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'right':
	          {
	            offset = this.state.frameWidth - this.state.slideWidth;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	      }
	
	      var left = this.state.slideWidth * target;
	      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
	
	      if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
	        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
	        offset = 0;
	        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
	      }
	
	      offset -= touchOffset || 0;
	      return (left - offset) * -1;
	    }
	  }, {
	    key: "getOffsetDeltas",
	    value: function getOffsetDeltas() {
	      var offset = 0;
	
	      if (this.state.isWrappingAround) {
	        offset = this.getTargetLeft(null, this.state.wrapToIndex);
	      } else {
	        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
	      }
	
	      return {
	        tx: [this.props.vertical ? 0 : offset],
	        ty: [this.props.vertical ? offset : 0]
	      };
	    } // Action Methods
	
	  }, {
	    key: "goToSlide",
	    value: function goToSlide(index, props) {
	      var _this6 = this;
	
	      if (props === undefined) {
	        props = this.props;
	      }
	
	      if (this.isTransitioning) {
	        return;
	      }
	
	      this.setState({
	        hasInteraction: true,
	        easing: easing[props.easing]
	      });
	      this.isTransitioning = true;
	      var previousSlide = this.state.currentSlide;
	
	      if (index >= this.state.slideCount || index < 0) {
	        if (!props.wrapAround) {
	          this.isTransitioning = false;
	          return;
	        }
	
	        if (index >= this.state.slideCount) {
	          props.beforeSlide(this.state.currentSlide, 0);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this6.getTargetLeft(_this6.state.slideWidth, prevState.currentSlide),
	              top: props.vertical ? _this6.getTargetLeft(_this6.state.slideWidth, prevState.currentSlide) : 0,
	              currentSlide: 0,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            setTimeout(function () {
	              _this6.resetAutoplay();
	
	              _this6.isTransitioning = false;
	
	              if (index !== previousSlide) {
	                _this6.props.afterSlide(0);
	              }
	            }, props.speed);
	          });
	          return;
	        } else {
	          var endSlide = this.state.slideCount - this.state.slidesToScroll;
	          props.beforeSlide(this.state.currentSlide, endSlide);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this6.getTargetLeft(0, prevState.currentSlide),
	              top: props.vertical ? _this6.getTargetLeft(0, prevState.currentSlide) : 0,
	              currentSlide: endSlide,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            setTimeout(function () {
	              _this6.resetAutoplay();
	
	              _this6.isTransitioning = false;
	
	              if (index !== previousSlide) {
	                _this6.props.afterSlide(_this6.state.slideCount - 1);
	              }
	            }, props.speed);
	          });
	          return;
	        }
	      }
	
	      this.props.beforeSlide(this.state.currentSlide, index);
	      this.setState({
	        currentSlide: index
	      }, function () {
	        return setTimeout(function () {
	          _this6.resetAutoplay();
	
	          _this6.isTransitioning = false;
	
	          if (index !== previousSlide) {
	            _this6.props.afterSlide(index);
	          }
	        }, props.speed);
	      });
	    }
	  }, {
	    key: "nextSlide",
	    value: function nextSlide() {
	      var childrenCount = this.state.slideCount;
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	      } else {
	        if (this.props.slideWidth !== 1) {
	          this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	          return;
	        }
	
	        var offset = this.state.currentSlide + this.state.slidesToScroll;
	        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : Math.min(offset, childrenCount - slidesToShow);
	        this.goToSlide(nextSlideIndex);
	      }
	    }
	  }, {
	    key: "previousSlide",
	    value: function previousSlide() {
	      if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
	      } else {
	        this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
	      }
	    } // Bootstrapping
	
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      if (_exenv["default"].canUseDOM) {
	        (0, _utilities.addEvent)(window, 'resize', this.onResize);
	        (0, _utilities.addEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.addEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.addEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "onResize",
	    value: function onResize() {
	      this.setDimensions(null, this.props.onResize);
	    }
	  }, {
	    key: "onReadyStateChange",
	    value: function onReadyStateChange() {
	      this.setDimensions();
	    }
	  }, {
	    key: "onVisibilityChange",
	    value: function onVisibilityChange() {
	      if (document.hidden) {
	        this.pauseAutoplay();
	      } else {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      if (_exenv["default"].canUseDOM) {
	        (0, _utilities.removeEvent)(window, 'resize', this.onResize);
	        (0, _utilities.removeEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.removeEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.removeEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "calcSlideHeightAndWidth",
	    value: function calcSlideHeightAndWidth(props) {
	      // slide height
	      props = props || this.props;
	      var childNodes = this.getChildNodes();
	      var slideHeight = (0, _bootstrappingUtilities.getSlideHeight)(props, this.state, childNodes); //slide width
	
	      var _getPropsByTransition = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow']),
	          slidesToShow = _getPropsByTransition.slidesToShow;
	
	      var frame = this.frame;
	      var slideWidth;
	
	      if (this.props.animation === 'zoom') {
	        slideWidth = frame.offsetWidth - frame.offsetWidth * 15 / 100;
	      } else if (typeof props.slideWidth !== 'number') {
	        slideWidth = parseInt(props.slideWidth);
	      } else if (props.vertical) {
	        slideWidth = slideHeight / slidesToShow * props.slideWidth;
	      } else {
	        slideWidth = frame.offsetWidth / slidesToShow * props.slideWidth;
	      }
	
	      if (!props.vertical) {
	        slideWidth -= props.cellSpacing * ((100 - 100 / slidesToShow) / 100);
	      }
	
	      return {
	        slideHeight: slideHeight,
	        slideWidth: slideWidth
	      };
	    }
	  }, {
	    key: "setSlideHeightAndWidth",
	    value: function setSlideHeightAndWidth() {
	      this.setState(this.calcSlideHeightAndWidth());
	    }
	  }, {
	    key: "setDimensions",
	    value: function setDimensions(props) {
	      var _this7 = this;
	
	      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	      props = props || this.props;
	
	      var _getPropsByTransition2 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow', 'cellAlign']),
	          slidesToShow = _getPropsByTransition2.slidesToShow,
	          cellAlign = _getPropsByTransition2.cellAlign;
	
	      var frame = this.frame;
	
	      var _this$calcSlideHeight = this.calcSlideHeightAndWidth(props),
	          slideHeight = _this$calcSlideHeight.slideHeight,
	          slideWidth = _this$calcSlideHeight.slideWidth;
	
	      var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
	
	      var _getPropsByTransition3 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToScroll']),
	          slidesToScroll = _getPropsByTransition3.slidesToScroll;
	
	      if (slidesToScroll === 'auto') {
	        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
	      }
	
	      this.setState({
	        frameWidth: frameWidth,
	        slideHeight: slideHeight,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        slideWidth: slideWidth,
	        cellAlign: cellAlign,
	        left: props.vertical ? 0 : this.getTargetLeft(),
	        top: props.vertical ? this.getTargetLeft() : 0
	      }, function () {
	        stateCb();
	
	        _this7.setLeft();
	      });
	    }
	  }, {
	    key: "getChildNodes",
	    value: function getChildNodes() {
	      return this.frame.childNodes[0].childNodes;
	    }
	  }, {
	    key: "setLeft",
	    value: function setLeft() {
	      var newLeft = this.props.vertical ? 0 : this.getTargetLeft();
	      var newTop = this.props.vertical ? this.getTargetLeft() : 0;
	
	      if (newLeft !== this.state.left || newTop !== this.state.top) {
	        this.setState({
	          left: newLeft,
	          top: newTop
	        });
	      }
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this8 = this;
	
	      if (this.props.withoutControls) {
	        return this.controlsMap.map(function () {
	          return null;
	        });
	      } else {
	        return this.controlsMap.map(function (_ref) {
	          var funcName = _ref.funcName,
	              key = _ref.key;
	          var func = _this8.props[funcName];
	          return func && typeof func === 'function' && _react["default"].createElement("div", {
	            className: "slider-control-".concat(key.toLowerCase()),
	            style: (0, _styleUtilities.getDecoratorStyles)(key),
	            key: key
	          }, func({
	            cellAlign: _this8.props.cellAlign,
	            cellSpacing: _this8.props.cellSpacing,
	            currentSlide: _this8.state.currentSlide,
	            frameWidth: _this8.state.frameWidth,
	            goToSlide: function goToSlide(index) {
	              return _this8.goToSlide(index);
	            },
	            nextSlide: function nextSlide() {
	              return _this8.nextSlide();
	            },
	            previousSlide: function previousSlide() {
	              return _this8.previousSlide();
	            },
	            slideCount: _this8.state.slideCount,
	            slidesToScroll: _this8.state.slidesToScroll,
	            slidesToShow: _this8.state.slidesToShow,
	            slideWidth: _this8.state.slideWidth,
	            wrapAround: _this8.props.wrapAround
	          }));
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      var _this$state = this.state,
	          currentSlide = _this$state.currentSlide,
	          slideCount = _this$state.slideCount,
	          frameWidth = _this$state.frameWidth;
	      var _this$props = this.props,
	          frameOverflow = _this$props.frameOverflow,
	          vertical = _this$props.vertical,
	          framePadding = _this$props.framePadding,
	          slidesToShow = _this$props.slidesToShow,
	          renderAnnounceSlideMessage = _this$props.renderAnnounceSlideMessage,
	          disableAnimation = _this$props.disableAnimation;
	      var duration = this.state.dragging || !this.state.dragging && this.state.resetWrapAroundPosition && this.props.wrapAround || disableAnimation || !this.state.hasInteraction ? 0 : this.props.speed;
	      var frameStyles = (0, _styleUtilities.getFrameStyles)(frameOverflow, vertical, framePadding, frameWidth);
	      var touchEvents = this.getTouchEvents();
	      var mouseEvents = this.getMouseEvents();
	      var TransitionControl = _allTransitions["default"][this.props.transitionMode];
	      var validChildren = (0, _bootstrappingUtilities.getValidChildren)(this.props.children);
	      return _react["default"].createElement("div", {
	        className: ['slider', this.props.className || ''].join(' '),
	        style: _extends({}, (0, _styleUtilities.getSliderStyles)(this.props.width, this.state.slideWidth), this.props.style)
	      }, !this.props.autoplay && _react["default"].createElement(_announceSlide["default"], {
	        message: renderAnnounceSlideMessage({
	          currentSlide: currentSlide,
	          slideCount: slideCount
	        })
	      }), _react["default"].createElement("div", _extends({
	        className: "slider-frame",
	        ref: function ref(frame) {
	          return _this9.frame = frame;
	        },
	        style: frameStyles
	      }, touchEvents, mouseEvents, {
	        onClickCapture: this.handleClick
	      }), _react["default"].createElement(_Animate["default"], {
	        show: true,
	        start: {
	          tx: 0,
	          ty: 0
	        },
	        update: function update() {
	          var _this9$getOffsetDelta = _this9.getOffsetDeltas(),
	              tx = _this9$getOffsetDelta.tx,
	              ty = _this9$getOffsetDelta.ty;
	
	          return {
	            tx: tx,
	            ty: ty,
	            timing: {
	              duration: duration,
	              ease: _this9.state.easing
	            },
	            events: {
	              end: function end() {
	                var newLeft = _this9.props.vertical ? 0 : _this9.getTargetLeft();
	                var newTop = _this9.props.vertical ? _this9.getTargetLeft() : 0;
	
	                if (newLeft !== _this9.state.left || newTop !== _this9.state.top) {
	                  _this9.setState({
	                    left: newLeft,
	                    top: newTop,
	                    isWrappingAround: false,
	                    resetWrapAroundPosition: true
	                  }, function () {
	                    _this9.setState({
	                      resetWrapAroundPosition: false
	                    });
	                  });
	                }
	              }
	            }
	          };
	        },
	        children: function children(_ref2) {
	          var tx = _ref2.tx,
	              ty = _ref2.ty;
	          return _react["default"].createElement(TransitionControl, _extends({}, (0, _styleUtilities.getTransitionProps)(_this9.props, _this9.state), {
	            deltaX: tx,
	            deltaY: ty
	          }), (0, _bootstrappingUtilities.addAccessibility)(validChildren, slidesToShow, currentSlide));
	        }
	      })), this.renderControls(), this.props.autoGenerateStyleTag && _react["default"].createElement("style", {
	        type: "text/css",
	        dangerouslySetInnerHTML: {
	          __html: (0, _styleUtilities.getImgTagStyles)()
	        }
	      }));
	    }
	  }]);
	
	  return Carousel;
	}(_react["default"].Component);
	
	exports["default"] = Carousel;
	Carousel.propTypes = {
	  afterSlide: _propTypes["default"].func,
	  animation: _propTypes["default"].oneOf(['zoom']),
	  autoGenerateStyleTag: _propTypes["default"].bool,
	  autoplay: _propTypes["default"].bool,
	  autoplayInterval: _propTypes["default"].number,
	  autoplayReverse: _propTypes["default"].bool,
	  beforeSlide: _propTypes["default"].func,
	  cellAlign: _propTypes["default"].oneOf(['left', 'center', 'right']),
	  cellSpacing: _propTypes["default"].number,
	  enableKeyboardControls: _propTypes["default"].bool,
	  disableAnimation: _propTypes["default"].bool,
	  dragging: _propTypes["default"].bool,
	  easing: _propTypes["default"].string,
	  edgeEasing: _propTypes["default"].string,
	  frameOverflow: _propTypes["default"].string,
	  framePadding: _propTypes["default"].string,
	  heightMode: _propTypes["default"].oneOf(['first', 'current', 'max']),
	  initialSlideHeight: _propTypes["default"].number,
	  initialSlideWidth: _propTypes["default"].number,
	  onResize: _propTypes["default"].func,
	  pauseOnHover: _propTypes["default"].bool,
	  renderAnnounceSlideMessage: _propTypes["default"].func,
	  renderBottomCenterControls: _propTypes["default"].func,
	  renderBottomLeftControls: _propTypes["default"].func,
	  renderBottomRightControls: _propTypes["default"].func,
	  renderCenterCenterControls: _propTypes["default"].func,
	  renderCenterLeftControls: _propTypes["default"].func,
	  renderCenterRightControls: _propTypes["default"].func,
	  renderTopCenterControls: _propTypes["default"].func,
	  renderTopLeftControls: _propTypes["default"].func,
	  renderTopRightControls: _propTypes["default"].func,
	  slideIndex: _propTypes["default"].number,
	  slideOffset: _propTypes["default"].number,
	  slidesToScroll: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['auto'])]),
	  slidesToShow: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  speed: _propTypes["default"].number,
	  swiping: _propTypes["default"].bool,
	  transitionMode: _propTypes["default"].oneOf(['scroll', 'fade', 'scroll3d']),
	  vertical: _propTypes["default"].bool,
	  width: _propTypes["default"].string,
	  withoutControls: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool,
	  opacityScale: _propTypes["default"].number,
	  slideListMargin: _propTypes["default"].number
	};
	Carousel.defaultProps = {
	  afterSlide: function afterSlide() {},
	  autoGenerateStyleTag: true,
	  autoplay: false,
	  autoplayInterval: 3000,
	  autoplayReverse: false,
	  beforeSlide: function beforeSlide() {},
	  cellAlign: 'left',
	  cellSpacing: 0,
	  enableKeyboardControls: false,
	  disableAnimation: false,
	  dragging: true,
	  easing: 'easeCircleOut',
	  edgeEasing: 'easeElasticOut',
	  frameOverflow: 'hidden',
	  framePadding: '0px',
	  heightMode: 'max',
	  onResize: function onResize() {},
	  pauseOnHover: true,
	  renderAnnounceSlideMessage: _announceSlide.defaultRenderAnnounceSlideMessage,
	  renderBottomCenterControls: function renderBottomCenterControls(props) {
	    return _react["default"].createElement(_defaultControls.PagingDots, props);
	  },
	  renderCenterLeftControls: function renderCenterLeftControls(props) {
	    return _react["default"].createElement(_defaultControls.PreviousButton, props);
	  },
	  renderCenterRightControls: function renderCenterRightControls(props) {
	    return _react["default"].createElement(_defaultControls.NextButton, props);
	  },
	  slideIndex: 0,
	  slideOffset: 25,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  slideWidth: 1,
	  speed: 500,
	  style: {},
	  swiping: true,
	  transitionMode: 'scroll',
	  vertical: false,
	  width: '100%',
	  withoutControls: false,
	  wrapAround: false,
	  slideListMargin: 10
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MIN_ZOOM_SCALE = 0;
	var MAX_ZOOM_SCALE = 1;
	
	var ScrollTransition3D =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ScrollTransition3D, _React$Component);
	
	  function ScrollTransition3D(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollTransition3D);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollTransition3D).call(this, props));
	    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ScrollTransition3D, [{
	    key: "getSlideDirection",
	    value: function getSlideDirection(start, end, isWrapping) {
	      var direction = 0;
	      if (start === end) return direction;
	
	      if (isWrapping) {
	        direction = start < end ? -1 : 1;
	      } else {
	        direction = start < end ? 1 : -1;
	      }
	
	      return direction;
	    }
	    /* eslint-disable complexity */
	
	  }, {
	    key: "getSlideTargetPosition",
	    value: function getSlideTargetPosition(index) {
	      var targetPosition = 0;
	      var offset = 0;
	
	      if (index !== this.props.currentSlide) {
	        var relativeDistanceToCurrentSlide = this.getRelativeDistanceToCurrentSlide(index);
	        targetPosition = (this.props.slideWidth + this.props.cellSpacing) * relativeDistanceToCurrentSlide - this.getZoomOffsetFor(relativeDistanceToCurrentSlide);
	        offset = 0;
	
	        if (this.props.animation === 'zoom' && (this.props.currentSlide === index + 1 || this.props.currentSlide === 0 && index === this.props.children.length - 1)) {
	          offset = this.props.slideOffset;
	        } else if (this.props.animation === 'zoom' && (this.props.currentSlide === index - 1 || this.props.currentSlide === this.props.children.length - 1 && index === 0)) {
	          offset = -this.props.slideOffset;
	        }
	      }
	
	      return targetPosition + offset;
	    }
	    /* eslint-enable complexity */
	
	  }, {
	    key: "formatChildren",
	    value: function formatChildren(children) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          top = _this$props.top,
	          left = _this$props.left,
	          currentSlide = _this$props.currentSlide,
	          slidesToShow = _this$props.slidesToShow;
	      var positionValue = this.props.vertical ? top : left;
	      return _react["default"].Children.map(children, function (child, index) {
	        var visible = _this2.getDistanceToCurrentSlide(index) <= slidesToShow / 2;
	        var current = currentSlide === index;
	        return _react["default"].createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : '').concat(current ? ' slide-current' : ''),
	          style: _this2.getSlideStyles(index, positionValue),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getZoomOffsetFor",
	    value: function getZoomOffsetFor(relativeDistanceToCurrent) {
	      if (relativeDistanceToCurrent === 0) {
	        return 0;
	      }
	
	      var marginGeneratedByZoom = (1 - Math.pow(this.props.zoomScale, Math.abs(relativeDistanceToCurrent))) * this.props.slideWidth;
	      var direction = relativeDistanceToCurrent < 0 ? -1 : 1;
	      var result = marginGeneratedByZoom * direction + this.getZoomOffsetFor(relativeDistanceToCurrent < 0 ? relativeDistanceToCurrent + 1 : relativeDistanceToCurrent - 1);
	      return result;
	    }
	  }, {
	    key: "getDistance",
	    value: function getDistance(index, referenceIndex) {
	      return Math.abs(index - referenceIndex);
	    }
	  }, {
	    key: "getDistanceToCurrentSlide",
	    value: function getDistanceToCurrentSlide(index) {
	      return this.props.wrapAround ? Math.min(Math.min(this.getDistance(index, 0) + this.getDistance(this.props.currentSlide, this.props.slideCount), this.getDistance(index, this.props.slideCount) + this.getDistance(this.props.currentSlide, 0)), this.getDistance(index, this.props.currentSlide)) : this.getDistance(index, this.props.currentSlide);
	    }
	  }, {
	    key: "getRelativeDistanceToCurrentSlide",
	    value: function getRelativeDistanceToCurrentSlide(index) {
	      if (this.props.wrapAround) {
	        var distanceByLeftEge = this.getDistance(index, 0) + this.getDistance(this.props.currentSlide, this.props.slideCount);
	        var distanceByRightEdge = this.getDistance(index, this.props.slideCount) + this.getDistance(this.props.currentSlide, 0);
	        var absoluteDirectDistance = this.getDistance(index, this.props.currentSlide);
	        var minimumDistance = Math.min(Math.min(distanceByLeftEge, distanceByRightEdge), absoluteDirectDistance);
	
	        switch (minimumDistance) {
	          case absoluteDirectDistance:
	            return index - this.props.currentSlide;
	
	          case distanceByLeftEge:
	            return distanceByLeftEge;
	
	          case distanceByRightEdge:
	            return -distanceByRightEdge;
	
	          default:
	            return 0;
	        }
	      } else {
	        return index - this.props.currentSlide;
	      }
	    }
	  }, {
	    key: "getTransformScale",
	    value: function getTransformScale(index) {
	      return this.props.currentSlide !== index ? Math.max(Math.min(Math.pow(this.props.zoomScale, this.getDistanceToCurrentSlide(index)), MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
	    }
	  }, {
	    key: "getOpacityScale",
	    value: function getOpacityScale(index) {
	      return this.props.currentSlide !== index ? Math.max(Math.min(Math.pow(this.props.opacityScale, this.getDistanceToCurrentSlide(index)), MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, positionValue) {
	      var targetPosition = this.getSlideTargetPosition(index, positionValue);
	      var transformScale = this.getTransformScale(index);
	      return {
	        zIndex: this.props.slideCount - this.getDistanceToCurrentSlide(index),
	        boxSizing: 'border-box',
	        display: this.props.vertical ? 'block' : 'inline-block',
	        height: 'auto',
	        left: this.props.vertical ? 0 : targetPosition,
	        listStyleType: 'none',
	        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        MozBoxSizing: 'border-box',
	        position: 'absolute',
	        top: this.props.vertical ? targetPosition : 0,
	        transform: "scale(".concat(transformScale, ")"),
	        transition: 'left 0.4s ease-out, transform 0.4s ease-out, opacity 0.4s ease-out',
	        verticalAlign: 'top',
	        width: this.props.vertical ? '100%' : this.props.slideWidth,
	        opacity: this.getOpacityScale(index)
	      };
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles() {
	      var listWidth = this.props.slideWidth * _react["default"].Children.count(this.props.children);
	
	      var spacingOffset = this.props.cellSpacing * _react["default"].Children.count(this.props.children);
	
	      return {
	        left: "calc(50% - (".concat(this.props.slideWidth, "px / 2))"),
	        position: 'relative',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "".concat(this.props.slideListMargin, "px ").concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
	        width: this.props.vertical ? 'auto' : '100%',
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.formatChildren(this.props.children);
	      return _react["default"].createElement("ul", {
	        className: "slider-list",
	        style: this.getListStyles()
	      }, children);
	    }
	  }]);
	
	  return ScrollTransition3D;
	}(_react["default"].Component);
	
	exports["default"] = ScrollTransition3D;
	ScrollTransition3D.propTypes = {
	  cellSpacing: _propTypes["default"].number,
	  currentSlide: _propTypes["default"].number,
	  dragging: _propTypes["default"].bool,
	  isWrappingAround: _propTypes["default"].bool,
	  left: _propTypes["default"].number,
	  slideCount: _propTypes["default"].number,
	  slideHeight: _propTypes["default"].number,
	  slideOffset: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  vertical: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool,
	  zoomScale: _propTypes["default"].number,
	  opacityScale: _propTypes["default"].number,
	  slidesToShow: _propTypes["default"].number,
	  slideListMargin: _propTypes["default"].number
	};
	ScrollTransition3D.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: true,
	  zoomScale: 0.75,
	  opacityScale: 0.65,
	  slidesToShow: 3,
	  slideListMargin: 10
	};

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var FadeTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(FadeTransition, _React$Component);
	
	  function FadeTransition(props) {
	    var _this;
	
	    _classCallCheck(this, FadeTransition);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(FadeTransition).call(this, props));
	    _this.fadeFromSlide = props.currentSlide;
	    return _this;
	  }
	
	  _createClass(FadeTransition, [{
	    key: "formatChildren",
	    value: function formatChildren(children, opacity) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          currentSlide = _this$props.currentSlide,
	          slidesToShow = _this$props.slidesToShow;
	      return _react["default"].Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react["default"].createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, opacity),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideOpacityAndLeftMap",
	    value: function getSlideOpacityAndLeftMap(fadeFrom, fadeTo, fade) {
	      // Figure out which position to fade to
	      var fadeToPosition = fadeTo;
	
	      if (fadeFrom > fade && fadeFrom === 0) {
	        fadeToPosition = fadeFrom - this.props.slidesToShow;
	      } else if (fadeFrom < fade && fadeFrom + this.props.slidesToShow > this.props.slideCount - 1) {
	        fadeToPosition = fadeFrom + this.props.slidesToShow;
	      } // Calculate opacity for active slides
	
	
	      var opacity = {};
	
	      if (fadeFrom === fadeTo) {
	        opacity[fadeFrom] = 1;
	      } else {
	        var distance = fadeFrom - fadeToPosition;
	        opacity[fadeFrom] = (fade - fadeToPosition) / distance;
	        opacity[fadeTo] = (fadeFrom - fade) / distance;
	      } // Calculate left for slides and merge in opacity
	
	
	      var map = {};
	
	      for (var i = 0; i < this.props.slidesToShow; i++) {
	        map[fadeFrom + i] = {
	          opacity: opacity[fadeFrom],
	          left: this.props.slideWidth * i
	        };
	        map[fadeTo + i] = {
	          opacity: opacity[fadeTo],
	          left: this.props.slideWidth * i
	        };
	      }
	
	      return map;
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, data) {
	      return {
	        boxSizing: 'border-box',
	        display: 'block',
	        height: 'auto',
	        left: data[index] ? data[index].left : 0,
	        listStyleType: 'none',
	        marginBottom: 'auto',
	        marginLeft: this.props.cellSpacing / 2,
	        marginRight: this.props.cellSpacing / 2,
	        marginTop: 'auto',
	        MozBoxSizing: 'border-box',
	        opacity: data[index] ? data[index].opacity : 0,
	        position: 'absolute',
	        top: 0,
	        verticalAlign: 'top',
	        visibility: data[index] ? 'inherit' : 'hidden',
	        width: this.props.slideWidth
	      };
	    }
	  }, {
	    key: "getContainerStyles",
	    value: function getContainerStyles() {
	      var width = this.props.slideWidth * this.props.slidesToShow;
	      return {
	        boxSizing: 'border-box',
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        display: 'block',
	        height: this.props.slideHeight,
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        MozBoxSizing: 'border-box',
	        padding: 0,
	        touchAction: 'none',
	        width: width
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var fade = -(this.props.deltaX || this.props.deltaY) / this.props.slideWidth;
	
	      if (parseInt(fade) === fade) {
	        this.fadeFromSlide = fade;
	      }
	
	      var opacityAndLeftMap = this.getSlideOpacityAndLeftMap(this.fadeFromSlide, this.props.currentSlide, fade);
	      var children = this.formatChildren(this.props.children, opacityAndLeftMap);
	      return _react["default"].createElement("ul", {
	        className: "slider-list",
	        style: this.getContainerStyles()
	      }, children);
	    }
	  }]);
	
	  return FadeTransition;
	}(_react["default"].Component);
	
	exports["default"] = FadeTransition;
	FadeTransition.propTypes = {
	  cellSpacing: _propTypes["default"].number,
	  currentSlide: _propTypes["default"].number,
	  deltaX: _propTypes["default"].number,
	  deltaY: _propTypes["default"].number,
	  dragging: _propTypes["default"].bool,
	  isWrappingAround: _propTypes["default"].bool,
	  left: _propTypes["default"].number,
	  slideCount: _propTypes["default"].number,
	  slideHeight: _propTypes["default"].number,
	  slidesToShow: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  vertical: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool
	};
	FadeTransition.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  deltaX: 0,
	  deltaY: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slidesToShow: 1,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: false
	};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MIN_ZOOM_SCALE = 0;
	var MAX_ZOOM_SCALE = 1;
	
	var ScrollTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ScrollTransition, _React$Component);
	
	  function ScrollTransition(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollTransition);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollTransition).call(this, props));
	    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ScrollTransition, [{
	    key: "getSlideDirection",
	    value: function getSlideDirection(start, end, isWrapping) {
	      var direction = 0;
	      if (start === end) return direction;
	
	      if (isWrapping) {
	        direction = start < end ? -1 : 1;
	      } else {
	        direction = start < end ? 1 : -1;
	      }
	
	      return direction;
	    }
	    /* eslint-disable complexity */
	
	  }, {
	    key: "getSlideTargetPosition",
	    value: function getSlideTargetPosition(index, positionValue) {
	      var targetPosition = (this.props.slideWidth + this.props.cellSpacing) * index;
	      var startSlide = Math.min(Math.abs(Math.floor(positionValue / this.props.slideWidth)), this.props.slideCount - 1);
	      var offset = 0;
	
	      if (this.props.animation === 'zoom' && (this.props.currentSlide === index + 1 || this.props.currentSlide === 0 && index === this.props.children.length - 1)) {
	        offset = this.props.slideOffset;
	      } else if (this.props.animation === 'zoom' && (this.props.currentSlide === index - 1 || this.props.currentSlide === this.props.children.length - 1 && index === 0)) {
	        offset = -this.props.slideOffset;
	      }
	
	      if (this.props.wrapAround && index !== startSlide) {
	        var direction = this.getSlideDirection(startSlide, this.props.currentSlide, this.props.isWrappingAround);
	        var slidesBefore = Math.floor((this.props.slideCount - 1) / 2);
	        var slidesAfter = this.props.slideCount - slidesBefore - 1;
	
	        if (direction < 0) {
	          var temp = slidesBefore;
	          slidesBefore = slidesAfter;
	          slidesAfter = temp;
	        }
	
	        var distanceFromStart = Math.abs(startSlide - index);
	
	        if (index < startSlide) {
	          if (distanceFromStart > slidesBefore) {
	            targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount + index);
	          }
	        } else if (distanceFromStart > slidesAfter) {
	          targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount - index) * -1;
	        }
	      }
	
	      return targetPosition + offset;
	    }
	    /* eslint-enable complexity */
	
	  }, {
	    key: "formatChildren",
	    value: function formatChildren(children) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          top = _this$props.top,
	          left = _this$props.left,
	          currentSlide = _this$props.currentSlide,
	          slidesToShow = _this$props.slidesToShow;
	      var positionValue = this.props.vertical ? top : left;
	      return _react["default"].Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react["default"].createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, positionValue),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, positionValue) {
	      var targetPosition = this.getSlideTargetPosition(index, positionValue);
	      var transformScale = this.props.animation === 'zoom' && this.props.currentSlide !== index ? Math.max(Math.min(this.props.zoomScale, MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
	      return {
	        boxSizing: 'border-box',
	        display: this.props.vertical ? 'block' : 'inline-block',
	        height: 'auto',
	        left: this.props.vertical ? 0 : targetPosition,
	        listStyleType: 'none',
	        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        MozBoxSizing: 'border-box',
	        position: 'absolute',
	        top: this.props.vertical ? targetPosition : 0,
	        transform: "scale(".concat(transformScale, ")"),
	        transition: 'transform .4s linear',
	        verticalAlign: 'top',
	        width: this.props.vertical ? '100%' : this.props.slideWidth
	      };
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles(styles) {
	      var deltaX = styles.deltaX,
	          deltaY = styles.deltaY;
	
	      var listWidth = this.props.slideWidth * _react["default"].Children.count(this.props.children);
	
	      var spacingOffset = this.props.cellSpacing * _react["default"].Children.count(this.props.children);
	
	      var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0)");
	      return {
	        transform: transform,
	        WebkitTransform: transform,
	        msTransform: "translate(".concat(deltaX, "px, ").concat(deltaY, "px)"),
	        position: 'relative',
	        display: 'block',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
	        width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.formatChildren(this.props.children);
	      var deltaX = this.props.deltaX;
	      var deltaY = this.props.deltaY;
	      return _react["default"].createElement("ul", {
	        className: "slider-list",
	        style: this.getListStyles({
	          deltaX: deltaX,
	          deltaY: deltaY
	        })
	      }, children);
	    }
	  }]);
	
	  return ScrollTransition;
	}(_react["default"].Component);
	
	exports["default"] = ScrollTransition;
	ScrollTransition.propTypes = {
	  animation: _propTypes["default"].oneOf(['zoom']),
	  cellSpacing: _propTypes["default"].number,
	  currentSlide: _propTypes["default"].number,
	  deltaX: _propTypes["default"].number,
	  deltaY: _propTypes["default"].number,
	  dragging: _propTypes["default"].bool,
	  isWrappingAround: _propTypes["default"].bool,
	  left: _propTypes["default"].number,
	  slideCount: _propTypes["default"].number,
	  slideHeight: _propTypes["default"].number,
	  slideOffset: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  vertical: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool,
	  zoomScale: _propTypes["default"].number
	};
	ScrollTransition.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  deltaX: 0,
	  deltaY: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: false,
	  zoomScale: 0.85
	};

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSlideHeight = exports.getValidChildren = exports.addAccessibility = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
	  var needsTabIndex;
	
	  if (slidesToShow > 1) {
	    return _react["default"].Children.map(children, function (child, index) {
	      // create a range from first visible slide to last visible slide
	      var firstVisibleSlide = index >= currentSlide;
	      var lastVisibleSlide = index < slidesToShow + currentSlide;
	      needsTabIndex = firstVisibleSlide && lastVisibleSlide; // if the index of the slide is in range add ariaProps to the slide
	
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      } : {
	        'aria-hidden': 'true'
	      };
	      return _react["default"].cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  } else {
	    // when slidesToshow is 1
	    return _react["default"].Children.map(children, function (child, index) {
	      needsTabIndex = index !== currentSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'true'
	      } : {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      };
	      return _react["default"].cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getValidChildren = function getValidChildren(children) {
	  // .toArray automatically removes invalid React children
	  return _react["default"].Children.toArray(children);
	};
	
	exports.getValidChildren = getValidChildren;
	
	var findMaxHeightSlide = function findMaxHeightSlide(slides) {
	  var maxHeight = 0;
	
	  for (var i = 0; i < slides.length; i++) {
	    if (slides[i].offsetHeight > maxHeight) {
	      maxHeight = slides[i].offsetHeight;
	    }
	  }
	
	  return maxHeight;
	};
	
	var getSlideHeight = function getSlideHeight(props, state) {
	  var childNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var heightMode = props.heightMode,
	      vertical = props.vertical,
	      initialSlideHeight = props.initialSlideHeight;
	  var slidesToShow = state.slidesToShow,
	      currentSlide = state.currentSlide;
	  var firstSlide = childNodes[0];
	
	  if (firstSlide && heightMode === 'first') {
	    return vertical ? firstSlide.offsetHeight * slidesToShow : firstSlide.offsetHeight;
	  }
	
	  if (heightMode === 'max') {
	    return findMaxHeightSlide(childNodes);
	  }
	
	  if (heightMode === 'current') {
	    return childNodes[currentSlide].offsetHeight;
	  }
	
	  return initialSlideHeight || 100;
	};
	
	exports.getSlideHeight = getSlideHeight;

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = exports.getFrameStyles = exports.getSliderStyles = exports.getDecoratorStyles = exports.getImgTagStyles = void 0;
	
	var getImgTagStyles = function getImgTagStyles() {
	  return ".slider-slide > img { width: 100%; display: block; }\n          .slider-slide > img:focus { margin: auto; }";
	};
	
	exports.getImgTagStyles = getImgTagStyles;
	
	var getDecoratorStyles = function getDecoratorStyles(position) {
	  switch (position) {
	    case 'TopLeft':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	
	    case 'TopCenter':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'TopRight':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          right: 0
	        };
	      }
	
	    case 'CenterLeft':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'CenterCenter':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: '50%',
	          transform: 'translate(-50%,-50%)',
	          WebkitTransform: 'translate(-50%, -50%)',
	          msTransform: 'translate(-50%, -50%)'
	        };
	      }
	
	    case 'CenterRight':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          right: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'BottomLeft':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: 0
	        };
	      }
	
	    case 'BottomCenter':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'BottomRight':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          right: 0
	        };
	      }
	
	    default:
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	  }
	};
	
	exports.getDecoratorStyles = getDecoratorStyles;
	
	var getSliderStyles = function getSliderStyles(propWidth, stateSlideWidth) {
	  return {
	    boxSizing: 'border-box',
	    display: 'block',
	    height: 'auto',
	    MozBoxSizing: 'border-box',
	    position: 'relative',
	    visibility: stateSlideWidth ? 'inherit' : 'hidden',
	    width: propWidth
	  };
	};
	
	exports.getSliderStyles = getSliderStyles;
	
	var getFrameStyles = function getFrameStyles(propFrameOverFlow, propVertical, propFramePadding, stateFrameWidth) {
	  return {
	    boxSizing: 'border-box',
	    display: 'block',
	    height: propVertical ? stateFrameWidth || 'initial' : '100%',
	    margin: propFramePadding,
	    MozBoxSizing: 'border-box',
	    msTransform: 'translate(0, 0)',
	    overflow: propFrameOverFlow,
	    padding: 0,
	    position: 'relative',
	    touchAction: "pinch-zoom ".concat(propVertical ? 'pan-x' : 'pan-y'),
	    transform: 'translate3d(0, 0, 0)',
	    WebkitTransform: 'translate3d(0, 0, 0)'
	  };
	};
	
	exports.getFrameStyles = getFrameStyles;
	
	var getTransitionProps = function getTransitionProps(props, state) {
	  return {
	    animation: props.animation,
	    cellSpacing: props.cellSpacing,
	    currentSlide: state.currentSlide,
	    dragging: props.dragging,
	    isWrappingAround: state.isWrappingAround,
	    left: state.left,
	    slideCount: state.slideCount,
	    slideHeight: state.slideHeight,
	    slideOffset: props.slideOffset,
	    slidesToShow: state.slidesToShow,
	    slideWidth: state.slideWidth,
	    top: state.top,
	    vertical: props.vertical,
	    wrapAround: props.wrapAround,
	    zoomScale: props.zoomScale,
	    opacityScale: props.opacityScale,
	    slideListMargin: props.slideListMargin
	  };
	};
	
	exports.getTransitionProps = getTransitionProps;

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcSomeInitialState = exports.shouldUpdate = exports.swipeDirection = exports.getPropsByTransitionMode = exports.addAccessibility = exports.removeEvent = exports.addEvent = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addEvent = function addEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.addEventListener) {
	    elem.addEventListener(type, eventHandle, false);
	  } else if (elem.attachEvent) {
	    elem.attachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = eventHandle;
	  }
	};
	
	exports.addEvent = addEvent;
	
	var removeEvent = function removeEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.removeEventListener) {
	    elem.removeEventListener(type, eventHandle, false);
	  } else if (elem.detachEvent) {
	    elem.detachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = null;
	  }
	};
	
	exports.removeEvent = removeEvent;
	
	var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
	  var needsTabIndex;
	
	  if (slidesToShow > 1) {
	    return _react["default"].Children.map(children, function (child, index) {
	      var firstVisibleSlide = index >= currentSlide;
	      var lastVisibleSlide = index < slidesToShow + currentSlide;
	      needsTabIndex = firstVisibleSlide && lastVisibleSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      } : {
	        'aria-hidden': 'true'
	      };
	      return _react["default"].cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  } else {
	    return _react["default"].Children.map(children, function (child, index) {
	      needsTabIndex = index !== currentSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'true'
	      } : {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      };
	      return _react["default"].cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getPropsByTransitionMode = function getPropsByTransitionMode(props, keys) {
	  var slidesToShow = props.slidesToShow,
	      transitionMode = props.transitionMode;
	  var updatedDefaults = {};
	
	  if (transitionMode === 'fade') {
	    keys.forEach(function (key) {
	      switch (key) {
	        case 'slidesToShow':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'slidesToScroll':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'cellAlign':
	          updatedDefaults[key] = 'left';
	          break;
	
	        default:
	          updatedDefaults[key] = props[key];
	          break;
	      }
	    });
	  } else {
	    keys.forEach(function (key) {
	      updatedDefaults[key] = props[key];
	    });
	  }
	
	  return updatedDefaults;
	};
	
	exports.getPropsByTransitionMode = getPropsByTransitionMode;
	
	var swipeDirection = function swipeDirection(x1, x2, y1, y2, vertical) {
	  var xDist = x1 - x2;
	  var yDist = y1 - y2;
	  var r = Math.atan2(yDist, xDist);
	  var swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0) {
	    return 1;
	  }
	
	  if (swipeAngle <= 360 && swipeAngle >= 315) {
	    return 1;
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return -1;
	  }
	
	  if (vertical === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return 1;
	    } else {
	      return -1;
	    }
	  }
	
	  return 0;
	};
	
	exports.swipeDirection = swipeDirection;
	
	var shouldUpdate = function shouldUpdate(curr, next, keys) {
	  var update = false;
	
	  for (var i = 0; i < keys.length; i++) {
	    if (curr[keys[i]] !== next[keys[i]]) {
	      update = true;
	      break;
	    }
	  }
	
	  return update;
	};
	
	exports.shouldUpdate = shouldUpdate;
	
	var calcSomeInitialState = function calcSomeInitialState(props) {
	  var _getPropsByTransition = getPropsByTransitionMode(props, ['slidesToScroll', 'slidesToShow', 'cellAlign']),
	      slidesToScroll = _getPropsByTransition.slidesToScroll,
	      slidesToShow = _getPropsByTransition.slidesToShow,
	      cellAlign = _getPropsByTransition.cellAlign;
	
	  var slideWidth = props.vertical ? props.initialSlideHeight || 0 : props.initialSlideWidth || 0;
	  var slideHeight = props.vertical ? (props.initialSlideHeight || 0) * props.slidesToShow : props.initialSlideHeight || 0;
	  var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	  var frameWidth = props.vertical ? frameHeight : '100%';
	  return {
	    slideWidth: slideWidth,
	    slideHeight: slideHeight,
	    frameWidth: frameWidth,
	    slidesToScroll: slidesToScroll,
	    slidesToShow: slidesToShow,
	    cellAlign: cellAlign
	  };
	};
	
	exports.calcSomeInitialState = calcSomeInitialState;

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {(function (global, factory) {
	   true ? factory(exports, __webpack_require__(1)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
	  (factory((global.reactAccessibleAccordion = {}),global.React));
	}(this, (function (exports,React) { 'use strict';
	
	  var React__default = 'default' in React ? React['default'] : React;
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	      var ownKeys = Object.keys(source);
	
	      if (typeof Object.getOwnPropertySymbols === 'function') {
	        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	        }));
	      }
	
	      ownKeys.forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    }
	
	    return target;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  // Arbitrary, but ought to be unique to avoid context namespace clashes.
	  var CONTEXT_KEY = 'react-accessible-accordion@AccordionContainer';
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Provider)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	        items: _this.props.items || []
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addItem", function (newItem) {
	        // Need to use callback style otherwise race-conditions are created by concurrent registrations.
	        _this.setState(function (state) {
	          var items;
	
	          if (state.items.some(function (item) {
	            return item.uuid === newItem.uuid;
	          })) {
	            // eslint-disable-next-line no-console
	            console.error("AccordionItem error: One item already has the uuid \"".concat(newItem.uuid, "\". Uuid property must be unique. See: https://github.com/springload/react-accessible-accordion#accordionitem"));
	          }
	
	          if (_this.props.accordion && newItem.expanded) {
	            // If this is a true accordion and the new item is expanded, then the others must be closed.
	            items = _toConsumableArray(state.items.map(function (item) {
	              return _objectSpread({}, item, {
	                expanded: false
	              });
	            })).concat([newItem]);
	          } else {
	            items = _toConsumableArray(state.items).concat([newItem]);
	          }
	
	          return {
	            items: items
	          };
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeItem", function (key) {
	        return _this.setState(function (state) {
	          return {
	            items: state.items.filter(function (item) {
	              return item.uuid !== key;
	            })
	          };
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setExpanded", function (key, expanded) {
	        return _this.setState(function (state) {
	          return {
	            items: state.items.map(function (item) {
	              if (item.uuid === key) {
	                return _objectSpread({}, item, {
	                  expanded: expanded
	                });
	              }
	
	              if (_this.props.accordion && expanded) {
	                // If this is an accordion, we might need to collapse the other expanded item.
	                return _objectSpread({}, item, {
	                  expanded: false
	                });
	              }
	
	              return item;
	            })
	          };
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(_this.props.accordion ? key : _this.state.items.filter(function (item) {
	              return item.expanded;
	            }).map(function (item) {
	              return item.uuid;
	            }));
	          }
	        });
	      });
	
	      return _this;
	    }
	
	    _createClass(Provider, [{
	      key: "getChildContext",
	      value: function getChildContext() {
	        var context = {
	          items: this.state.items,
	          accordion: !!this.props.accordion,
	          addItem: this.addItem,
	          removeItem: this.removeItem,
	          setExpanded: this.setExpanded
	        };
	        return _defineProperty({}, CONTEXT_KEY, context);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return this.props.children || null;
	      }
	    }]);
	
	    return Provider;
	  }(React.Component); // eslint-disable-next-line react/no-multi-comp
	
	  _defineProperty(Provider, "childContextTypes", _defineProperty({}, CONTEXT_KEY, function () {
	    return null;
	  }));
	
	  var Consumer =
	  /*#__PURE__*/
	  function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      _classCallCheck(this, Consumer);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
	    }
	
	    _createClass(Consumer, [{
	      key: "render",
	      value: function render() {
	        return this.props.children(this.context[CONTEXT_KEY]);
	      }
	    }]);
	
	    return Consumer;
	  }(React.Component);
	
	  _defineProperty(Consumer, "contextTypes", _defineProperty({}, CONTEXT_KEY, function () {
	    return null;
	  }));
	
	  var accordionDefaultProps = {
	    accordion: true
	  };
	
	  var Accordion = function Accordion(_ref) {
	    var accordion = _ref.accordion,
	        rest = _objectWithoutProperties(_ref, ["accordion"]);
	
	    return React__default.createElement("div", _extends({
	      role: accordion ? 'tablist' : null
	    }, rest));
	  };
	
	  Accordion.defaultProps = accordionDefaultProps;
	
	  var defaultProps = {
	    accordion: true,
	    onChange: function onChange() {},
	    className: 'accordion',
	    children: null
	  };
	
	  var AccordionWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(AccordionWrapper, _Component);
	
	    function AccordionWrapper() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, AccordionWrapper);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderAccordion", function (accordionStore) {
	        var _this$props = _this.props,
	            accordion = _this$props.accordion,
	            onChange = _this$props.onChange,
	            rest = _objectWithoutProperties(_this$props, ["accordion", "onChange"]);
	
	        return React__default.createElement(Accordion, _extends({
	          accordion: accordionStore.accordion
	        }, rest));
	      });
	
	      return _this;
	    }
	
	    _createClass(AccordionWrapper, [{
	      key: "render",
	      value: function render() {
	        return React__default.createElement(Provider, {
	          accordion: this.props.accordion,
	          onChange: this.props.onChange
	        }, React__default.createElement(Consumer, null, this.renderAccordion));
	      }
	    }]);
	
	    return AccordionWrapper;
	  }(React.Component);
	
	  _defineProperty(AccordionWrapper, "defaultProps", defaultProps);
	
	  function _extends$1() {
	    _extends$1 = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends$1.apply(this, arguments);
	  }
	
	  /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @typechecks
	   * 
	   */
	
	  function _inheritsLoose$1(subClass, superClass) {
	    subClass.prototype = Object.create(superClass.prototype);
	    subClass.prototype.constructor = subClass;
	    subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   */
	
	  function unwrapExports (x) {
	  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	  }
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  var lib = createCommonjsModule(function (module, exports) {
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	    var currentListeners = [];
	    var nextListeners = currentListeners;
	
	    function ensureCanMutateNextListeners() {
	      if (nextListeners === currentListeners) {
	        nextListeners = currentListeners.slice();
	      }
	    }
	
	    function listen(listener) {
	      if (typeof listener !== 'function') {
	        throw new Error('Expected listener to be a function.');
	      }
	
	      var isSubscribed = true;
	      ensureCanMutateNextListeners();
	      nextListeners.push(listener);
	      return function () {
	        if (!isSubscribed) {
	          return;
	        }
	
	        isSubscribed = false;
	        ensureCanMutateNextListeners();
	        var index = nextListeners.indexOf(listener);
	        nextListeners.splice(index, 1);
	      };
	    }
	
	    function emit() {
	      currentListeners = nextListeners;
	      var listeners = currentListeners;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i].apply(listeners, arguments);
	      }
	    }
	
	    return {
	      listen: listen,
	      emit: emit
	    };
	  };
	  });
	
	  unwrapExports(lib);
	  var lib_1 = lib.createChangeEmitter;
	
	  function symbolObservablePonyfill(root) {
	    var result;
	    var Symbol = root.Symbol;
	
	    if (typeof Symbol === 'function') {
	      if (Symbol.observable) {
	        result = Symbol.observable;
	      } else {
	        result = Symbol('observable');
	        Symbol.observable = result;
	      }
	    } else {
	      result = '@@observable';
	    }
	
	    return result;
	  }
	
	  /* global window */
	  var root;
	
	  if (typeof self !== 'undefined') {
	    root = self;
	  } else if (typeof window !== 'undefined') {
	    root = window;
	  } else if (typeof global !== 'undefined') {
	    root = global;
	  } else if (true) {
	    root = module;
	  } else {
	    root = Function('return this')();
	  }
	
	  var result = symbolObservablePonyfill(root);
	
	  var Nothing =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose$1(Nothing, _Component);
	
	    function Nothing() {
	      return _Component.apply(this, arguments) || this;
	    }
	
	    var _proto = Nothing.prototype;
	
	    _proto.render = function render() {
	      return null;
	    };
	
	    return Nothing;
	  }(React.Component);
	
	  var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
	    if (renderPropName === void 0) {
	      renderPropName = 'children';
	    }
	
	    return function (BaseComponent) {
	      var baseFactory = React__default.createFactory(BaseComponent);
	      var renderPropsFactory = React__default.createFactory(RenderPropsComponent);
	
	      var FromRenderProps = function FromRenderProps(ownerProps) {
	        var _renderPropsFactory;
	
	        return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
	          return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
	        }, _renderPropsFactory));
	      };
	
	      return FromRenderProps;
	    };
	  };
	
	  var compose = function compose() {
	    for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	      funcs[_key] = arguments[_key];
	    }
	
	    return funcs.reduce(function (a, b) {
	      return function () {
	        return a(b.apply(void 0, arguments));
	      };
	    }, function (arg) {
	      return arg;
	    });
	  };
	
	  /*!
	   * consecutive
	   * Get consecutive numbers
	   * Copyright(c) 2017 ivanoff .$ curl -A cv ivanoff.org.ua
	   * MIT Licensed
	   */
	
	  var consecutive = function (begin, base, inc) {
	    var number = begin || 0;
	    if (typeof base !== 'number') base = 10;
	    if (typeof inc !== 'number') inc = 1;
	    return function () {
	      var res;
	
	      if (typeof base === 'undefined' || base === 10) {
	        res = number;
	        number += inc;
	      } else {
	        res = number.toString();
	        number = (parseInt(number, base) + inc).toString(base);
	      }
	
	      return res;
	    };
	  };
	
	  // Arbitrary, but ought to be unique to avoid context namespace clashes.
	  var CONTEXT_KEY$1 = 'react-accessible-accordion@ItemContainer';
	  var Provider$1 =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      _classCallCheck(this, Provider);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
	    }
	
	    _createClass(Provider, [{
	      key: "getChildContext",
	      value: function getChildContext() {
	        var uuid = this.props.uuid;
	        var context = {
	          uuid: uuid
	        };
	        return _defineProperty({}, CONTEXT_KEY$1, context);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return this.props.children || null;
	      }
	    }]);
	
	    return Provider;
	  }(React.Component);
	
	  _defineProperty(Provider$1, "childContextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
	    return null;
	  }));
	
	  // eslint-disable-next-line react/no-multi-comp
	  var Consumer$1 =
	  /*#__PURE__*/
	  function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      _classCallCheck(this, Consumer);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
	    }
	
	    _createClass(Consumer, [{
	      key: "render",
	      value: function render() {
	        return this.props.children(this.context[CONTEXT_KEY$1]);
	      }
	    }]);
	
	    return Consumer;
	  }(React.Component);
	
	  _defineProperty(Consumer$1, "contextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
	    return null;
	  }));
	
	  var classnames = createCommonjsModule(function (module) {
	  /*!
	    Copyright (c) 2016 Jed Watson.
	    Licensed under the MIT License (MIT), see
	    http://jedwatson.github.io/classnames
	  */
	
	  /* global define */
	  (function () {
	
	    var hasOwn = {}.hasOwnProperty;
	
	    function classNames() {
	      var classes = [];
	
	      for (var i = 0; i < arguments.length; i++) {
	        var arg = arguments[i];
	        if (!arg) continue;
	        var argType = typeof arg;
	
	        if (argType === 'string' || argType === 'number') {
	          classes.push(arg);
	        } else if (Array.isArray(arg)) {
	          classes.push(classNames.apply(null, arg));
	        } else if (argType === 'object') {
	          for (var key in arg) {
	            if (hasOwn.call(arg, key) && arg[key]) {
	              classes.push(key);
	            }
	          }
	        }
	      }
	
	      return classes.join(' ');
	    }
	
	    if (module.exports) {
	      module.exports = classNames;
	    } else if (false) {
	      // register as 'classnames', consistent with npm package name
	      undefined('classnames', [], function () {
	        return classNames;
	      });
	    } else {
	      window.classNames = classNames;
	    }
	  })();
	  });
	
	  var AccordionItem =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(AccordionItem, _Component);
	
	    function AccordionItem() {
	      _classCallCheck(this, AccordionItem);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItem).apply(this, arguments));
	    }
	
	    _createClass(AccordionItem, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this$props = this.props,
	            uuid = _this$props.uuid,
	            accordionStore = _this$props.accordionStore,
	            disabled = _this$props.disabled;
	        accordionStore.addItem({
	          uuid: uuid,
	          expanded: this.props.expanded || false,
	          disabled: disabled
	        });
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.props.accordionStore.removeItem(this.props.uuid);
	      } // This is here so that the user can dynamically set the 'expanded' state using the 'expanded' prop.
	
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        var _this$props2 = this.props,
	            uuid = _this$props2.uuid,
	            expanded = _this$props2.expanded,
	            accordionStore = _this$props2.accordionStore;
	
	        if (expanded !== prevProps.expanded) {
	          accordionStore.setExpanded(uuid, expanded);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this$props3 = this.props,
	            uuid = _this$props3.uuid,
	            className = _this$props3.className,
	            hideBodyClassName = _this$props3.hideBodyClassName,
	            accordionStore = _this$props3.accordionStore,
	            disabled = _this$props3.disabled,
	            expanded = _this$props3.expanded,
	            rest = _objectWithoutProperties(_this$props3, ["uuid", "className", "hideBodyClassName", "accordionStore", "disabled", "expanded"]); // Deliberately not using 'find' because IE compat.
	
	
	        var currentItem = accordionStore.items.filter(function (item) {
	          return item.uuid === uuid;
	        })[0];
	
	        if (!currentItem) {
	          return null;
	        }
	
	        return React__default.createElement("div", _extends({
	          className: classnames(className, _defineProperty({}, hideBodyClassName, !currentItem.expanded && hideBodyClassName))
	        }, rest));
	      }
	    }]);
	
	    return AccordionItem;
	  }(React.Component);
	
	  var nextUuid = consecutive();
	  function resetNextUuid() {
	    nextUuid = consecutive();
	  }
	
	  var AccordionItemWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(AccordionItemWrapper, _Component);
	
	    function AccordionItemWrapper() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, AccordionItemWrapper);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "id", nextUuid());
	
	      return _this;
	    }
	
	    _createClass(AccordionItemWrapper, [{
	      key: "render",
	      value: function render() {
	        var _this$props = this.props,
	            accordionStore = _this$props.accordionStore,
	            uuid = _this$props.uuid,
	            rest = _objectWithoutProperties(_this$props, ["accordionStore", "uuid"]);
	
	        var itemUuid = uuid !== undefined ? uuid : this.id;
	        return React__default.createElement(Provider$1, {
	          uuid: itemUuid
	        }, React__default.createElement(AccordionItem, _extends({}, rest, {
	          uuid: itemUuid,
	          accordionStore: accordionStore
	        })));
	      }
	    }]);
	
	    return AccordionItemWrapper;
	  }(React.Component);
	
	  _defineProperty(AccordionItemWrapper, "defaultProps", {
	    className: 'accordion__item',
	    hideBodyClassName: '',
	    disabled: false,
	    expanded: false,
	    uuid: undefined
	  });
	
	  var AccordionItem_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
	    return {
	      accordionStore: accordionStore
	    };
	  }))(AccordionItemWrapper);
	
	  var AccordionItemTitle =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(AccordionItemTitle, _Component);
	
	    function AccordionItemTitle() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, AccordionItemTitle);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemTitle)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
	        var _this$props = _this.props,
	            uuid = _this$props.uuid,
	            expanded = _this$props.expanded,
	            setExpanded = _this$props.setExpanded;
	        setExpanded(uuid, !expanded);
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyPress", function (evt) {
	        if (evt.charCode === 13 || evt.charCode === 32) {
	          evt.preventDefault();
	
	          _this.handleClick();
	        }
	      });
	
	      return _this;
	    }
	
	    _createClass(AccordionItemTitle, [{
	      key: "render",
	      value: function render() {
	        var _this$props2 = this.props,
	            className = _this$props2.className,
	            hideBodyClassName = _this$props2.hideBodyClassName,
	            item = _this$props2.item,
	            accordion = _this$props2.accordion,
	            setExpanded = _this$props2.setExpanded,
	            expanded = _this$props2.expanded,
	            uuid = _this$props2.uuid,
	            disabled = _this$props2.disabled,
	            rest = _objectWithoutProperties(_this$props2, ["className", "hideBodyClassName", "item", "accordion", "setExpanded", "expanded", "uuid", "disabled"]);
	
	        var id = "accordion__title-".concat(uuid);
	        var ariaControls = "accordion__body-".concat(uuid);
	        var role = accordion ? 'tab' : 'button';
	        var titleClassName = classnames(className, _defineProperty({}, hideBodyClassName, hideBodyClassName && !expanded));
	
	        if (role === 'tab') {
	          return React__default.createElement("div", _extends({
	            id: id,
	            "aria-selected": expanded,
	            "aria-controls": ariaControls,
	            className: titleClassName,
	            onClick: disabled ? undefined : this.handleClick,
	            role: role,
	            tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
	            ,
	            onKeyPress: this.handleKeyPress,
	            disabled: disabled
	          }, rest));
	        }
	
	        return React__default.createElement("div", _extends({
	          id: id,
	          "aria-expanded": expanded,
	          "aria-controls": ariaControls,
	          className: titleClassName,
	          onClick: disabled ? undefined : this.handleClick,
	          role: role,
	          tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
	          ,
	          onKeyPress: this.handleKeyPress,
	          disabled: disabled
	        }, rest));
	      }
	    }]);
	
	    return AccordionItemTitle;
	  }(React.Component);
	
	  _defineProperty(AccordionItemTitle, "accordionElementName", 'AccordionItemTitle');
	
	  // eslint-disable-next-line react/prefer-stateless-function
	  var AccordionItemTitleWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(AccordionItemTitleWrapper, _Component);
	
	    function AccordionItemTitleWrapper() {
	      _classCallCheck(this, AccordionItemTitleWrapper);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemTitleWrapper).apply(this, arguments));
	    }
	
	    _createClass(AccordionItemTitleWrapper, [{
	      key: "render",
	      value: function render() {
	        var _this$props = this.props,
	            itemStore = _this$props.itemStore,
	            accordionStore = _this$props.accordionStore,
	            rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);
	
	        var uuid = itemStore.uuid;
	        var items = accordionStore.items,
	            accordion = accordionStore.accordion;
	        var item = items.filter(function (stateItem) {
	          return stateItem.uuid === uuid;
	        })[0];
	        return React__default.createElement(AccordionItemTitle, _extends({}, rest, item, {
	          setExpanded: accordionStore.setExpanded,
	          accordion: accordion
	        }));
	      }
	    }]);
	
	    return AccordionItemTitleWrapper;
	  }(React.Component);
	
	  _defineProperty(AccordionItemTitleWrapper, "defaultProps", {
	    className: 'accordion__title',
	    hideBodyClassName: ''
	  });
	
	  var AccordionItemTitle_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
	    return {
	      accordionStore: accordionStore
	    };
	  }), fromRenderProps(Consumer$1, function (itemStore) {
	    return {
	      itemStore: itemStore
	    };
	  }))(AccordionItemTitleWrapper);
	
	  var AccordionItemBody = function AccordionItemBody(props) {
	    var className = props.className,
	        hideBodyClassName = props.hideBodyClassName,
	        uuid = props.uuid,
	        expanded = props.expanded,
	        disabled = props.disabled,
	        accordion = props.accordion,
	        rest = _objectWithoutProperties(props, ["className", "hideBodyClassName", "uuid", "expanded", "disabled", "accordion"]);
	
	    return React__default.createElement("div", _extends({
	      id: "accordion__body-".concat(uuid),
	      className: classnames(className, _defineProperty({}, hideBodyClassName, !expanded)),
	      "aria-hidden": !expanded,
	      "aria-labelledby": "accordion__title-".concat(uuid),
	      role: accordion ? 'tabpanel' : null
	    }, rest));
	  };
	
	  // eslint-disable-next-line react/prefer-stateless-function
	  var AccordionItemBodyWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(AccordionItemBodyWrapper, _Component);
	
	    function AccordionItemBodyWrapper() {
	      _classCallCheck(this, AccordionItemBodyWrapper);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemBodyWrapper).apply(this, arguments));
	    }
	
	    _createClass(AccordionItemBodyWrapper, [{
	      key: "render",
	      value: function render() {
	        var _this$props = this.props,
	            itemStore = _this$props.itemStore,
	            accordionStore = _this$props.accordionStore,
	            rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);
	
	        var uuid = itemStore.uuid;
	        var items = accordionStore.items,
	            accordion = accordionStore.accordion;
	        var item = items.filter(function (stateItem) {
	          return stateItem.uuid === uuid;
	        })[0];
	        return item ? React__default.createElement(AccordionItemBody, _extends({}, rest, item, {
	          accordion: accordion
	        })) : null;
	      }
	    }]);
	
	    return AccordionItemBodyWrapper;
	  }(React.Component);
	
	  _defineProperty(AccordionItemBodyWrapper, "defaultProps", {
	    className: 'accordion__body',
	    hideBodyClassName: 'accordion__body--hidden'
	  });
	
	  var AccordionItemBody_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
	    return {
	      accordionStore: accordionStore
	    };
	  }), fromRenderProps(Consumer$1, function (itemStore) {
	    return {
	      itemStore: itemStore
	    };
	  }))(AccordionItemBodyWrapper);
	
	  // eslint-disable-next-line
	
	  exports.Accordion = AccordionWrapper;
	  exports.AccordionItem = AccordionItem_wrapper;
	  exports.AccordionItemTitle = AccordionItemTitle_wrapper;
	  exports.AccordionItemBody = AccordionItemBody_wrapper;
	  exports.resetNextUuid = resetNextUuid;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(842)(module)))

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _NodeGroup = _interopRequireDefault(__webpack_require__(244));
	
	var _utils = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var keyAccessor = function keyAccessor() {
	  return '$$key$$';
	};
	
	var Animate = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate() {
	    _classCallCheck(this, Animate);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Animate).apply(this, arguments));
	  }
	
	  _createClass(Animate, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          show = _this$props.show,
	          start = _this$props.start,
	          enter = _this$props.enter,
	          update = _this$props.update,
	          leave = _this$props.leave,
	          interpolation = _this$props.interpolation,
	          children = _this$props.children;
	      var data = typeof start === 'function' ? start() : start;
	      return _react.default.createElement(_NodeGroup.default, {
	        data: show ? [data] : [],
	        start: function start() {
	          return data;
	        },
	        keyAccessor: keyAccessor,
	        interpolation: interpolation,
	        enter: typeof enter === 'function' ? enter : function () {
	          return enter;
	        },
	        update: typeof update === 'function' ? update : function () {
	          return update;
	        },
	        leave: typeof leave === 'function' ? leave : function () {
	          return leave;
	        }
	      }, function (nodes) {
	        if (!nodes[0]) {
	          return null;
	        }
	
	        var renderedChildren = children(nodes[0].state);
	        return renderedChildren && _react.default.Children.only(renderedChildren);
	      });
	    }
	  }]);
	
	  return Animate;
	}(_react.Component);
	
	Animate.propTypes =  false ? {
	  show: _propTypes.default.bool,
	  interpolation: _propTypes.default.func,
	  start: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	  enter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  update: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  leave: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  children: _propTypes.default.func.isRequired
	} : {};
	Animate.defaultProps = {
	  show: true,
	  interpolation: _utils.numeric
	};
	var _default = Animate;
	exports.default = _default;

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(242);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _kapellmeister = __webpack_require__(214);
	
	var _mergeKeys = _interopRequireDefault(__webpack_require__(245));
	
	var _types = __webpack_require__(246);
	
	var _utils = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NodeGroup = function (_Component) {
	  _inherits(NodeGroup, _Component);
	
	  function NodeGroup(props) {
	    var _this;
	
	    _classCallCheck(this, NodeGroup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeGroup).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "animate", function () {
	      var _this$state = _this.state,
	          nodeKeys = _this$state.nodeKeys,
	          nodeHash = _this$state.nodeHash;
	
	      if (_this.unmounting) {
	        return;
	      }
	
	      var pending = false;
	      var nextNodeKeys = [];
	      var length = nodeKeys.length;
	
	      for (var i = 0; i < length; i++) {
	        var k = nodeKeys[i];
	        var n = nodeHash[k];
	        var isTransitioning = n.isTransitioning();
	
	        if (isTransitioning) {
	          pending = true;
	        }
	
	        if (n.type === _types.LEAVE && !isTransitioning) {
	          delete nodeHash[k];
	        } else {
	          nextNodeKeys.push(k);
	        }
	      }
	
	      if (!pending) {
	        _this.interval.stop();
	      }
	
	      _this.setState(function () {
	        return {
	          nodeKeys: nextNodeKeys,
	          nodes: nextNodeKeys.map(function (key) {
	            return nodeHash[key];
	          })
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "interval", null);
	
	    _defineProperty(_assertThisInitialized(_this), "unmounting", false);
	
	    var interpolation = props.interpolation;
	
	    var Node = function (_BaseNode) {
	      _inherits(Node, _BaseNode);
	
	      function Node(key, data) {
	        var _this2;
	
	        _classCallCheck(this, Node);
	
	        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this));
	
	        _defineProperty(_assertThisInitialized(_this2), "getInterpolator", interpolation);
	
	        _this2.key = key;
	        _this2.data = data;
	        _this2.type = _types.ENTER;
	        return _this2;
	      }
	
	      return Node;
	    }(_kapellmeister.BaseNode);
	
	    _this.state = {
	      Node: Node,
	      nodeKeys: [],
	      nodeHash: {},
	      nodes: [],
	      data: null
	    };
	    return _this;
	  }
	
	  _createClass(NodeGroup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startInterval();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.data !== this.props.data && !this.unmounting) {
	        this.startInterval();
	      }
	    }
	  }, {
	    key: "startInterval",
	    value: function startInterval() {
	      if (!this.interval) {
	        this.interval = (0, _kapellmeister.interval)(this.animate);
	      } else {
	        this.interval.restart(this.animate);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this$state2 = this.state,
	          nodeKeys = _this$state2.nodeKeys,
	          nodeHash = _this$state2.nodeHash;
	      this.unmounting = true;
	
	      if (this.interval) {
	        this.interval.stop();
	      }
	
	      nodeKeys.forEach(function (key) {
	        nodeHash[key].stopTransitions();
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var renderedChildren = this.props.children(this.state.nodes);
	      return renderedChildren && _react.default.Children.only(renderedChildren);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.data !== prevState.data) {
	        var data = nextProps.data,
	            keyAccessor = nextProps.keyAccessor,
	            start = nextProps.start,
	            enter = nextProps.enter,
	            update = nextProps.update,
	            leave = nextProps.leave;
	        var Node = prevState.Node,
	            nodeKeys = prevState.nodeKeys,
	            nodeHash = prevState.nodeHash;
	        var keyIndex = {};
	
	        for (var i = 0; i < nodeKeys.length; i++) {
	          keyIndex[nodeKeys[i]] = i;
	        }
	
	        var nextKeyIndex = {};
	        var nextNodeKeys = [];
	
	        for (var _i = 0; _i < data.length; _i++) {
	          var d = data[_i];
	          var k = keyAccessor(d, _i);
	          nextKeyIndex[k] = _i;
	          nextNodeKeys.push(k);
	
	          if (keyIndex[k] === undefined) {
	            var node = new Node();
	            node.key = k;
	            node.data = d;
	            node.type = _types.ENTER;
	            nodeHash[k] = node;
	          }
	        }
	
	        for (var _i2 = 0; _i2 < nodeKeys.length; _i2++) {
	          var _k = nodeKeys[_i2];
	          var n = nodeHash[_k];
	
	          if (nextKeyIndex[_k] !== undefined) {
	            n.data = data[nextKeyIndex[_k]];
	            n.type = _types.UPDATE;
	          } else {
	            n.type = _types.LEAVE;
	          }
	        }
	
	        var mergedNodeKeys = (0, _mergeKeys.default)(nodeKeys, keyIndex, nextNodeKeys, nextKeyIndex);
	
	        for (var _i3 = 0; _i3 < mergedNodeKeys.length; _i3++) {
	          var _k2 = mergedNodeKeys[_i3];
	          var _n = nodeHash[_k2];
	          var _d = _n.data;
	
	          if (_n.type === _types.ENTER) {
	            _n.setState(start(_d, nextKeyIndex[_k2]));
	
	            _n.transition(enter(_d, nextKeyIndex[_k2]));
	          } else if (_n.type === _types.LEAVE) {
	            _n.transition(leave(_d, keyIndex[_k2]));
	          } else {
	            _n.transition(update(_d, nextKeyIndex[_k2]));
	          }
	        }
	
	        return {
	          data: data,
	          nodes: mergedNodeKeys.map(function (key) {
	            return nodeHash[key];
	          }),
	          nodeHash: nodeHash,
	          nodeKeys: mergedNodeKeys
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return NodeGroup;
	}(_react.Component);
	
	NodeGroup.propTypes =  false ? {
	  data: _propTypes.default.array.isRequired,
	  keyAccessor: _propTypes.default.func.isRequired,
	  interpolation: _propTypes.default.func,
	  start: _propTypes.default.func.isRequired,
	  enter: _propTypes.default.func,
	  update: _propTypes.default.func,
	  leave: _propTypes.default.func,
	  children: _propTypes.default.func.isRequired
	} : {};
	NodeGroup.defaultProps = {
	  enter: function enter() {},
	  update: function update() {},
	  leave: function leave() {},
	  interpolation: _utils.numeric
	};
	(0, _reactLifecyclesCompat.polyfill)(NodeGroup);
	var _default = NodeGroup;
	exports.default = _default;

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function mergeKeys(currNodeKeys, currKeyIndex, nextNodeKeys, nextKeyIndex) {
	  var allKeys = [];
	
	  for (var i = 0; i < nextNodeKeys.length; i++) {
	    allKeys[i] = nextNodeKeys[i];
	  }
	
	  for (var _i = 0; _i < currNodeKeys.length; _i++) {
	    if (nextKeyIndex[currNodeKeys[_i]] === undefined) {
	      allKeys.push(currNodeKeys[_i]);
	    }
	  }
	
	  return allKeys.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a];
	    var nextOrderB = nextKeyIndex[b];
	    var currOrderA = currKeyIndex[a];
	    var currOrderB = currKeyIndex[b];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      return nextKeyIndex[a] - nextKeyIndex[b];
	    } else if (currOrderA != null && currOrderB != null) {
	      return currKeyIndex[a] - currKeyIndex[b];
	    } else if (nextOrderA != null) {
	      for (var _i2 = 0; _i2 < nextNodeKeys.length; _i2++) {
	        var pivot = nextNodeKeys[_i2];
	
	        if (!currKeyIndex[pivot]) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && currOrderB > currKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && currOrderB < currKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	
	      return 1;
	    }
	
	    for (var _i3 = 0; _i3 < nextNodeKeys.length; _i3++) {
	      var _pivot = nextNodeKeys[_i3];
	
	      if (!currKeyIndex[_pivot]) {
	        continue;
	      }
	
	      if (nextOrderB < nextKeyIndex[_pivot] && currOrderA > currKeyIndex[_pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[_pivot] && currOrderA < currKeyIndex[_pivot]) {
	        return -1;
	      }
	    }
	
	    return -1;
	  });
	}
	
	var _default = mergeKeys;
	exports.default = _default;

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LEAVE = exports.UPDATE = exports.ENTER = void 0;
	var ENTER = 'ENTER';
	exports.ENTER = ENTER;
	var UPDATE = 'UPDATE';
	exports.UPDATE = UPDATE;
	var LEAVE = 'LEAVE';
	exports.LEAVE = LEAVE;

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numeric = numeric;
	
	function numeric(beg, end) {
	  var a = +beg;
	  var b = +end - a;
	  return function (t) {
	    return a + b * t;
	  };
	}

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(t,e){ true?e(exports,__webpack_require__(1)):"function"==typeof define&&define.amd?define(["exports","react"],e):e(t.ReactSizes={},t.React)}(this,function(t,e){"use strict";function n(t,e,n){function o(e){var n=l,r=p;return l=p=void 0,v=e,h=t.apply(r,n)}function a(t){var n=t-y;return void 0===y||n>=e||0>n||m&&t-v>=d}function u(){var t=T();if(a(t))return c(t);b=setTimeout(u,function(t){var n=e-(t-y);return m?O(n,d-(t-v)):n}(t))}function c(t){return b=void 0,k&&l?o(t):(l=p=void 0,h)}function s(){var t=T(),n=a(t);if(l=arguments,p=this,y=t,n){if(void 0===b)return function(t){return v=t,b=setTimeout(u,e),g?o(t):h}(y);if(m)return b=setTimeout(u,e),o(y)}return void 0===b&&(b=setTimeout(u,e)),h}var l,p,d,h,b,y,v=0,g=!1,m=!1,k=!0;if("function"!=typeof t)throw new TypeError(f);return e=i(e)||0,r(n)&&(g=!!n.leading,d=(m="maxWait"in n)?w(i(n.maxWait)||0,e):d,k="trailing"in n?!!n.trailing:k),s.cancel=function(){void 0!==b&&clearTimeout(b),v=0,l=y=p=b=void 0},s.flush=function(){return void 0===b?h:c(T())},s}function r(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function i(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||!!t&&"object"==typeof t&&m.call(t)==s}(t))return c;if(r(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=r(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(l,"");var n=d.test(t);return n||h.test(t)?b(t.slice(2),n?2:8):p.test(t)?c:+t}function o(t){return function(){return t}}var a="default"in e?e.default:e,u="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},f="Expected a function",c=NaN,s="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,d=/^0b[01]+$/i,h=/^0o[0-7]+$/i,b=parseInt,y="object"==typeof u&&u&&u.Object===Object&&u,v="object"==typeof self&&self&&self.Object===Object&&self,g=y||v||Function("return this")(),m=Object.prototype.toString,w=Math.max,O=Math.min,T=function(){return g.Date.now()},k=function(t,e,i){var o=!0,a=!0;if("function"!=typeof t)throw new TypeError(f);return r(i)&&(o="leading"in i?!!i.leading:o,a="trailing"in i?!!i.trailing:a),n(t,e,{leading:o,maxWait:e,trailing:a})},j=function(t,e){for(var n in t)if(!(n in e))return!0;for(var r in e)if(t[r]!==e[r])return!0;return!1},P=function(t){var e=t.fallbackWidth,n=void 0===e?null:e,r=t.fallbackHeight,i=void 0===r?null:r,o="undefined"!=typeof window;return{width:o?window.innerWidth:n,height:o?window.innerHeight:i,canUseDOM:o}},S=function(){};S.thatReturns=o,S.thatReturnsFalse=o(!1),S.thatReturnsTrue=o(!0),S.thatReturnsNull=o(null),S.thatReturnsThis=function(){return this},S.thatReturnsArgument=function(t){return t};var _=S,x=function(t,e,n,r,i,o,a,u){if(!t){var f;if(void 0===e)f=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,i,o,a,u],s=0;(f=Error(e.replace(/%s/g,function(){return c[s++]}))).name="Invariant Violation"}throw f.framesToPop=1,f}},z="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",W=function(t,e){return e={exports:{}},t(e,e.exports),e.exports}(function(t){t.exports=function(){function t(t,e,n,r,i,o){o!==z&&x(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e};return n.checkPropTypes=_,n.PropTypes=n,n}()}),E=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},R=function(){function t(t,e){for(var n=0;e.length>n;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),C=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t},D=Object.assign||function(t){for(var e=1;arguments.length>e;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},H=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)},M=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e},A="_ReactSizesConfig_",F=C({},A,W.shape({fallbackWidth:W.number,fallbackHeight:W.number,throttle:W.number})),N=function(t){return 480>t.width},I=function(t){return t.width>=1024},U=function(t){return!I(t)},L=Object.freeze({isMobile:N,isTablet:function(t){var e=t.width;return e>=480&&1024>e},isDesktop:I,isGtMobile:function(t){return!N(t)},isGtTablet:function(t){return I(t)},isStTablet:function(t){return N(t)},isStDesktop:U,isTabletAndGreater:function(t){return!N(t)},isTabletAndSmaller:function(t){return!U(t)}}),$=Object.assign(function(){for(var t=arguments.length,n=Array(t),r=0;t>r;r++)n[r]=arguments[r];return function(t){var r,i,o=function(t,e){return n.map(function(n){return n(t,e)}).reduce(function(t,e){return D({},t,e)},{})};return i=r=function(n){function r(t,e){E(this,r);var n=M(this,(r.__proto__||Object.getPrototypeOf(r)).call(this,t,e));return n.dispatchSizes=function(){var t=n.getPropsToPass();j(t,n.state.propsToPass)&&n.setState({propsToPass:t})},n.throttledDispatchSizes=k(n.dispatchSizes,(n.context[A]||{}).throttle||200),n.getWindowSizesWithFallback=function(){var t=n.context[A]||{},e=t.fallbackHeight,r=t.fallbackWidth;return P({fallbackHeight:void 0===e?null:e,fallbackWidth:void 0===r?null:r})},n.getPropsToPass=function(){return o(n.getWindowSizesWithFallback(),n.props)},n.state={initialSizes:n.getWindowSizesWithFallback(),propsToPass:n.getPropsToPass()},n}return H(r,e.Component),R(r,[{key:"componentDidMount",value:function(){window.addEventListener("resize",this.throttledDispatchSizes),this.dispatchSizes()}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.throttledDispatchSizes)}},{key:"render",value:function(){return a.createElement(t,D({},this.props,this.state.propsToPass))}}]),r}(),r.displayName="withSizes("+(t.displayName||t.name||("string"==typeof t&&t.length>0?t:"Unknown"))+")",r.contextTypes=F,i}},D({},L)),G=function(t){function n(){return E(this,n),M(this,(n.__proto__||Object.getPrototypeOf(n)).apply(this,arguments))}return H(n,e.Component),R(n,[{key:"getChildContext",value:function(){var t=this.props.config,e=void 0===t?{}:t;return C({},A,{fallbackWidth:e.fallbackWidth||null,fallbackHeight:e.fallbackHeight||null,throttle:e.throttle||200})}},{key:"render",value:function(){return this.props.children}}]),n}();G.childContextTypes=F;var q=function(t){var e=t.children,n=t.render,r=function(t,e){var n={};for(var r in t)0>e.indexOf(r)&&Object.prototype.hasOwnProperty.call(t,r)&&(n[r]=t[r]);return n}(t,["children","render"]),i=e||n;return i?i(r):null};t.withSizes=$,t.SizesProvider=G,t.createSizedComponent=function(){for(var t=arguments.length,e=Array(t),n=0;t>n;n++)e[n]=arguments[n];return $(e)(q)},t.presets=L,t.default=$,Object.defineProperty(t,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _Cursor = __webpack_require__(10);
	
		var _Cursor2 = _interopRequireDefault(_Cursor);
	
		var _Backspace = __webpack_require__(12);
	
		var _Backspace2 = _interopRequireDefault(_Backspace);
	
		var _Delay = __webpack_require__(13);
	
		var _Delay2 = _interopRequireDefault(_Delay);
	
		var _utils = __webpack_require__(14);
	
		var utils = _interopRequireWildcard(_utils);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ACTION_CHARS = ['🔙', '⏰'];
	
		var Typist = function (_Component) {
		  _inherits(Typist, _Component);
	
		  function Typist(props) {
		    _classCallCheck(this, Typist);
	
		    var _this = _possibleConstructorReturn(this, (Typist.__proto__ || Object.getPrototypeOf(Typist)).call(this, props));
	
		    _this.state = {
		      textLines: [],
		      isDone: false
		    };
	
		    _this.onTypingDone = function () {
		      if (!_this.mounted) {
		        return;
		      }
		      _this.setState({ isDone: true });
		      _this.props.onTypingDone();
		    };
	
		    _this.delayGenerator = function (line, lineIdx, character, charIdx) {
		      var mean = _this.props.avgTypingDelay;
		      var std = _this.props.stdTypingDelay;
	
		      return _this.props.delayGenerator(mean, std, {
		        line: line,
		        lineIdx: lineIdx,
		        character: character,
		        charIdx: charIdx,
		        defDelayGenerator: function defDelayGenerator() {
		          var mn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mean;
		          var st = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : std;
		          return utils.gaussianRnd(mn, st);
		        }
		      });
		    };
	
		    _this.typeLine = function (line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
	
		      var decoratedLine = line;
		      var onLineTyped = _this.props.onLineTyped;
	
	
		      if (utils.isBackspaceElement(line)) {
		        if (line.props.delay > 0) {
		          _this.introducedDelay = line.props.delay;
		        }
		        decoratedLine = String('🔙').repeat(line.props.count);
		      } else if (utils.isDelayElement(line)) {
		        _this.introducedDelay = line.props.ms;
		        decoratedLine = '⏰';
		      }
	
		      return new Promise(function (resolve, reject) {
		        _this.setState({ textLines: _this.state.textLines.concat(['']) }, function () {
		          utils.eachPromise(decoratedLine, _this.typeCharacter, decoratedLine, lineIdx).then(function () {
		            return onLineTyped(decoratedLine, lineIdx);
		          }).then(resolve).catch(reject);
		        });
		      });
		    };
	
		    _this.typeCharacter = function (character, charIdx, line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
		      var onCharacterTyped = _this.props.onCharacterTyped;
	
	
		      return new Promise(function (resolve) {
		        var textLines = _this.state.textLines.slice();
	
		        utils.sleep(_this.introducedDelay).then(function () {
		          _this.introducedDelay = null;
	
		          var isBackspace = character === '🔙';
		          var isDelay = character === '⏰';
		          if (isDelay) {
		            resolve();
		            return;
		          }
	
		          if (isBackspace && lineIdx > 0) {
		            var prevLineIdx = lineIdx - 1;
		            var prevLine = textLines[prevLineIdx];
	
		            for (var idx = prevLineIdx; idx >= 0; idx--) {
		              if (prevLine.length > 0 && !ACTION_CHARS.includes(prevLine[0])) {
		                break;
		              }
		              prevLineIdx = idx;
		              prevLine = textLines[prevLineIdx];
		            }
	
		            textLines[prevLineIdx] = prevLine.substr(0, prevLine.length - 1);
		          } else {
		            textLines[lineIdx] += character;
		          }
	
		          _this.setState({ textLines: textLines }, function () {
		            var delay = _this.delayGenerator(line, lineIdx, character, charIdx);
		            onCharacterTyped(character, charIdx);
		            setTimeout(resolve, delay);
		          });
		        });
		      });
		    };
	
		    _this.mounted = false;
		    _this.linesToType = [];
		    _this.introducedDelay = null;
	
		    if (props.children) {
		      _this.linesToType = utils.extractTextFromElement(props.children);
		    }
		    return _this;
		  }
	
		  _createClass(Typist, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.mounted = true;
		      var _props = this.props,
		          children = _props.children,
		          startDelay = _props.startDelay;
	
		      if (children) {
		        if (startDelay > 0 && typeof window !== 'undefined') {
		          setTimeout(this.typeAllLines.bind(this), startDelay);
		        } else {
		          this.typeAllLines();
		        }
		      } else {
		        this.onTypingDone();
		      }
		    }
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function shouldComponentUpdate(nextProps, nextState) {
		      if (nextState.textLines.length !== this.state.textLines.length) {
		        return true;
		      }
		      for (var idx = 0; idx < nextState.textLines.length; idx++) {
		        var line = this.state.textLines[idx];
		        var nextLine = nextState.textLines[idx];
		        if (line !== nextLine) {
		          return true;
		        }
		      }
		      return this.state.isDone !== nextState.isDone;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.mounted = false;
		    }
		  }, {
		    key: 'typeAllLines',
		    value: function typeAllLines() {
		      var _this2 = this;
	
		      var lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.linesToType;
	
		      return utils.eachPromise(lines, this.typeLine).then(function () {
		        return _this2.onTypingDone();
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props2 = this.props,
		          className = _props2.className,
		          cursor = _props2.cursor;
		      var isDone = this.state.isDone;
	
		      var innerTree = utils.cloneElementWithSpecifiedText({
		        element: this.props.children,
		        textLines: this.state.textLines
		      });
	
		      return _react2.default.createElement(
		        'div',
		        { className: 'Typist ' + className },
		        innerTree,
		        _react2.default.createElement(_Cursor2.default, _extends({ isDone: isDone }, cursor))
		      );
		    }
		  }]);
	
		  return Typist;
		}(_react.Component);
	
		Typist.propTypes = {
		  children: _propTypes2.default.node,
		  className: _propTypes2.default.string,
		  avgTypingDelay: _propTypes2.default.number,
		  stdTypingDelay: _propTypes2.default.number,
		  startDelay: _propTypes2.default.number,
		  cursor: _propTypes2.default.object,
		  onCharacterTyped: _propTypes2.default.func,
		  onLineTyped: _propTypes2.default.func,
		  onTypingDone: _propTypes2.default.func,
		  delayGenerator: _propTypes2.default.func
		};
		Typist.defaultProps = {
		  className: '',
		  avgTypingDelay: 70,
		  stdTypingDelay: 25,
		  startDelay: 0,
		  cursor: {},
		  onCharacterTyped: function onCharacterTyped() {},
		  onLineTyped: function onLineTyped() {},
		  onTypingDone: function onTypingDone() {},
		  delayGenerator: utils.gaussianRnd
		};
		exports.default = Typist;
	
	
		Typist.Backspace = _Backspace2.default;
		Typist.Delay = _Delay2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		if (false) {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(3)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(9)();
		}
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var warning = __webpack_require__(6);
	
		var ReactPropTypesSecret = __webpack_require__(7);
		var checkPropTypes = __webpack_require__(8);
	
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    if (false) {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (false) {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (false) {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (false) {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
	
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
	
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
	
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
	
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
	
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
	
		module.exports = warning;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		if (false) {
		  var invariant = __webpack_require__(5);
		  var warning = __webpack_require__(6);
		  var ReactPropTypesSecret = __webpack_require__(7);
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (false) {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		module.exports = checkPropTypes;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var ReactPropTypesSecret = __webpack_require__(7);
	
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		__webpack_require__(11);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Cursor = function (_Component) {
		  _inherits(Cursor, _Component);
	
		  function Cursor(props) {
		    _classCallCheck(this, Cursor);
	
		    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, props));
	
		    _this._isReRenderingCursor = false;
		    _this.state = {
		      shouldRender: _this.props.show
		    };
		    return _this;
		  }
	
		  _createClass(Cursor, [{
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps) {
		      var _this2 = this;
	
		      var shouldHide = !this.props.isDone && nextProps.isDone && this.props.hideWhenDone;
		      if (shouldHide) {
		        setTimeout(function () {
		          return _this2.setState({ shouldRender: false });
		        }, this.props.hideWhenDoneDelay);
		      }
		    }
		  }, {
		    key: 'componentDidUpdate',
		    value: function componentDidUpdate() {
		      var _props = this.props,
		          show = _props.show,
		          isDone = _props.isDone;
	
		      if (!show) {
		        return;
		      }
		      if (isDone) {
		        return;
		      }
		      if (this._isReRenderingCursor) {
		        return;
		      }
	
		      // In webkit and blink, rendering the cursor alongside the text as it
		      // animates sometimes causes the text to stop rendering when it reaches
		      // a new line break, even though the underlying DOM /does/ contain
		      // the text. This seems to happen when the space available for the text is
		      // at a specific width that makes it so the line break happens within a
		      // word.
		      // Using dev tools, when in this state, if you modify the dom or any style,
		      // it immediately renders all of the text in its correct position.
		      // Given that observation, this is a hackish solutions that re-renders the
		      // cursor every time a character is rendered, just to ensure that the text
		      // is rendered correctly.
		      // See #13 and #15 for more details
		      this._reRenderCursor();
		    }
		  }, {
		    key: '_reRenderCursor',
		    value: function _reRenderCursor() {
		      var _this3 = this;
	
		      this._isReRenderingCursor = true;
		      this.setState({ shouldRender: false }, function () {
		        _this3.setState({ shouldRender: true }, function () {
		          _this3._isReRenderingCursor = false;
		        });
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      if (this.state.shouldRender) {
		        var className = this.props.blink ? ' Cursor--blinking' : '';
		        return _react2.default.createElement(
		          'span',
		          { className: 'Cursor' + className },
		          this.props.element
		        );
		      }
		      return null;
		    }
		  }]);
	
		  return Cursor;
		}(_react.Component);
	
		Cursor.propTypes = {
		  blink: _propTypes2.default.bool,
		  show: _propTypes2.default.bool,
		  element: _propTypes2.default.node,
		  hideWhenDone: _propTypes2.default.bool,
		  hideWhenDoneDelay: _propTypes2.default.number,
		  isDone: _propTypes2.default.bool
		};
		Cursor.defaultProps = {
		  blink: true,
		  show: true,
		  element: '|',
		  hideWhenDone: false,
		  hideWhenDoneDelay: 1000,
		  isDone: false
		};
		exports.default = Cursor;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Backspace = function Backspace() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Backspace.componentName = 'Backspace';
	
		Backspace.propTypes = {
		  count: _propTypes2.default.number,
		  delay: _propTypes2.default.number
		};
	
		Backspace.defaultProps = {
		  count: 1,
		  delay: 0
		};
	
		exports.default = Backspace;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Delay = function Delay() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Delay.componentName = 'Delay';
	
		Delay.propTypes = {
		  ms: _propTypes2.default.number.isRequired
		};
	
		exports.default = Delay;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.sleep = undefined;
	
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
		exports.gaussianRnd = gaussianRnd;
		exports.eachPromise = eachPromise;
		exports.exclude = exclude;
		exports.isBackspaceElement = isBackspaceElement;
		exports.isDelayElement = isDelayElement;
		exports.extractTextFromElement = extractTextFromElement;
		exports.cloneElement = cloneElement;
		exports.cloneElementWithSpecifiedText = cloneElementWithSpecifiedText;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		var sleep = exports.sleep = function sleep(val) {
		  return new Promise(function (resolve) {
		    return val != null ? setTimeout(resolve, val) : resolve();
		  });
		};
	
		function gaussianRnd(mean, std) {
		  var times = 12;
		  var sum = 0;
		  for (var idx = 0; idx < times; idx++) {
		    sum += Math.random();
		  }
		  sum -= times / 2;
		  return Math.round(sum * std) + mean;
		}
	
		function eachPromise(arr, iterator) {
		  for (var _len = arguments.length, extraArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		    extraArgs[_key - 2] = arguments[_key];
		  }
	
		  var promiseReducer = function promiseReducer(prev, current, idx) {
		    return prev.then(function () {
		      return iterator.apply(undefined, [current, idx].concat(extraArgs));
		    });
		  };
		  return Array.from(arr).reduce(promiseReducer, Promise.resolve());
		}
	
		function exclude(obj, keys) {
		  var res = {};
		  for (var key in obj) {
		    if (keys.indexOf(key) === -1) {
		      res[key] = obj[key];
		    }
		  }
		  return res;
		}
	
		function isBackspaceElement(element) {
		  return element && element.type && element.type.componentName === 'Backspace';
		}
	
		function isDelayElement(element) {
		  return element && element.type && element.type.componentName === 'Delay';
		}
	
		function extractTextFromElement(element) {
		  var stack = element ? [element] : [];
		  var lines = [];
	
		  while (stack.length > 0) {
		    var current = stack.pop();
		    if (_react2.default.isValidElement(current)) {
		      if (isBackspaceElement(current) || isDelayElement(current)) {
		        // If it is a `Backspace` or `Delay` element, we want to keep it in our
		        // `textLines` state. These will serve as markers when updating the
		        // state of the text
		        lines.unshift(current);
		      } else {
		        _react2.default.Children.forEach(current.props.children, function (child) {
		          stack.push(child);
		        });
		      }
		    } else if (Array.isArray(current)) {
		      var _iteratorNormalCompletion = true;
		      var _didIteratorError = false;
		      var _iteratorError = undefined;
	
		      try {
		        for (var _iterator = current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		          var el = _step.value;
	
		          stack.push(el);
		        }
		      } catch (err) {
		        _didIteratorError = true;
		        _iteratorError = err;
		      } finally {
		        try {
		          if (!_iteratorNormalCompletion && _iterator.return) {
		            _iterator.return();
		          }
		        } finally {
		          if (_didIteratorError) {
		            throw _iteratorError;
		          }
		        }
		      }
		    } else {
		      lines.unshift(current);
		    }
		  }
	
		  return lines;
		}
	
		function cloneElement(element, children) {
		  var tag = element.type;
		  var props = exclude(element.props, ['children']);
		  var getMilliseconds = new Date().getUTCMilliseconds();
		  var randomStamp = getMilliseconds + Math.random() + Math.random();
		  // eslint-disable-next-line
		  props.key = 'Typist-element-' + tag + '-' + randomStamp;
		  return _react2.default.createElement.apply(_react2.default, [tag, props].concat(_toConsumableArray(children)));
		}
	
		function cloneElementWithSpecifiedTextAtIndex(element, textLines, textIdx) {
		  if (textIdx >= textLines.length) {
		    return [null, textIdx];
		  }
	
		  var idx = textIdx;
		  var recurse = function recurse(el) {
		    var _cloneElementWithSpec = cloneElementWithSpecifiedTextAtIndex(el, textLines, idx),
		        _cloneElementWithSpec2 = _slicedToArray(_cloneElementWithSpec, 2),
		        child = _cloneElementWithSpec2[0],
		        advIdx = _cloneElementWithSpec2[1];
	
		    idx = advIdx;
		    return child;
		  };
	
		  var isNonTypistElement = _react2.default.isValidElement(element) && !(isBackspaceElement(element) || isDelayElement(element));
	
		  if (isNonTypistElement) {
		    var clonedChildren = _react2.default.Children.map(element.props.children, recurse) || [];
		    return [cloneElement(element, clonedChildren), idx];
		  }
	
		  if (Array.isArray(element)) {
		    var children = element.map(recurse);
		    return [children, idx];
		  }
	
		  // Anything that isn't a React element or an Array is interpreted as text
		  return [textLines[idx], idx + 1];
		}
	
		function cloneElementWithSpecifiedText(_ref) {
		  var element = _ref.element,
		      textLines = _ref.textLines;
	
		  if (!element) {
		    return undefined;
		  }
	
		  return cloneElementWithSpecifiedTextAtIndex(element, textLines, 0)[0];
		}
	
	/***/ })
	/******/ ]);

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AvatarModule = __webpack_require__(203);
	
	var _AvatarModule2 = _interopRequireDefault(_AvatarModule);
	
	var _vars = __webpack_require__(209);
	
	var _vars2 = _interopRequireDefault(_vars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Avatar = function Avatar(props) {
	  var avatarStyle = {
	    backgroundImage: 'url(' + props.photo + '), linear-gradient(to top, ' + _vars2.default.blue + ', ' + _vars2.default.green + ')'
	  };
	  return _react2.default.createElement('div', { className: _AvatarModule2.default.avatar, style: avatarStyle });
	};
	
	exports.default = Avatar;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"blue":"#00A8E8","green":"#99C24D","avatar":"src-components-Avatar----Avatar-module---avatar---3hTp9"};

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bind = __webpack_require__(105);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ButtonModule = __webpack_require__(114);
	
	var _ButtonModule2 = _interopRequireDefault(_ButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_ButtonModule2.default);
	
	var Button = function Button(props) {
	  var className = cx({
	    btn: true,
	    orange: props.orange,
	    large: props.large
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _ButtonModule2.default.button },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.link, className: className },
	      props.title
	    )
	  );
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dark":"#00171F","blue":"#00A8E8","white":"#FFFFFF","green":"#99C24D","btn":"src-components-Button----Button-module---btn---32eKb","orange":"src-components-Button----Button-module---orange---2uJg3 src-components-Button----Button-module---btn---32eKb","normal":"src-components-Button----Button-module---normal---1Zpch src-components-Button----Button-module---btn---32eKb","large":"src-components-Button----Button-module---large---2DwLF src-components-Button----Button-module---btn---32eKb"};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Divider = __webpack_require__(47);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _IconGridModule = __webpack_require__(205);
	
	var _IconGridModule2 = _interopRequireDefault(_IconGridModule);
	
	var _Inner = __webpack_require__(48);
	
	var _Inner2 = _interopRequireDefault(_Inner);
	
	var _handshake = __webpack_require__(96);
	
	var _handshake2 = _interopRequireDefault(_handshake);
	
	var _backup = __webpack_require__(90);
	
	var _backup2 = _interopRequireDefault(_backup);
	
	var _consulting = __webpack_require__(92);
	
	var _consulting2 = _interopRequireDefault(_consulting);
	
	var _disasterRecovery = __webpack_require__(93);
	
	var _disasterRecovery2 = _interopRequireDefault(_disasterRecovery);
	
	var _networking = __webpack_require__(97);
	
	var _networking2 = _interopRequireDefault(_networking);
	
	var _globe = __webpack_require__(95);
	
	var _globe2 = _interopRequireDefault(_globe);
	
	var _firewall = __webpack_require__(94);
	
	var _firewall2 = _interopRequireDefault(_firewall);
	
	var _server = __webpack_require__(98);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _audit = __webpack_require__(89);
	
	var _audit2 = _interopRequireDefault(_audit);
	
	var _virtualization = __webpack_require__(99);
	
	var _virtualization2 = _interopRequireDefault(_virtualization);
	
	var _consolidation = __webpack_require__(91);
	
	var _consolidation2 = _interopRequireDefault(_consolidation);
	
	var _workstations = __webpack_require__(103);
	
	var _workstations2 = _interopRequireDefault(_workstations);
	
	var _dataRecovery = __webpack_require__(100);
	
	var _dataRecovery2 = _interopRequireDefault(_dataRecovery);
	
	var _secureDataDelete = __webpack_require__(102);
	
	var _secureDataDelete2 = _interopRequireDefault(_secureDataDelete);
	
	var _ransom = __webpack_require__(101);
	
	var _ransom2 = _interopRequireDefault(_ransom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconGrid = function IconGrid(props) {
	  var icons = props.items.map(function (item) {
	    function theIcon(item) {
	      var rawIcon = item.node.childMarkdownRemark.frontmatter.icon;
	      if (rawIcon == '/assets/secure-data-delete.svg') {
	        return _react2.default.createElement(_secureDataDelete2.default, null);
	      }
	      if (rawIcon == '/assets/data-recovery.svg') {
	        return _react2.default.createElement(_dataRecovery2.default, null);
	      }
	      if (rawIcon == '/assets/handshake.svg') {
	        return _react2.default.createElement(_handshake2.default, null);
	      }
	      if (rawIcon == '/assets/backup.svg') {
	        return _react2.default.createElement(_backup2.default, null);
	      }
	      if (rawIcon == '/assets/consulting.svg') {
	        return _react2.default.createElement(_consulting2.default, null);
	      }
	      if (rawIcon == '/assets/disaster-recovery.svg') {
	        return _react2.default.createElement(_disasterRecovery2.default, null);
	      }
	      if (rawIcon == '/assets/networking5.svg') {
	        return _react2.default.createElement(_networking2.default, null);
	      }
	      if (rawIcon == '/assets/globe.svg') {
	        return _react2.default.createElement(_globe2.default, null);
	      }
	      if (rawIcon == '/assets/firewall.svg') {
	        return _react2.default.createElement(_firewall2.default, null);
	      }
	      if (rawIcon == '/assets/server.svg') {
	        return _react2.default.createElement(_server2.default, null);
	      }
	      if (rawIcon == '/assets/audit2.svg') {
	        return _react2.default.createElement(_audit2.default, null);
	      }
	      if (rawIcon == '/assets/virtualization.svg') {
	        return _react2.default.createElement(_virtualization2.default, null);
	      }
	      if (rawIcon == '/assets/consolidation.svg') {
	        return _react2.default.createElement(_consolidation2.default, null);
	      }
	      if (rawIcon == '/assets/workstations.svg') {
	        return _react2.default.createElement(_workstations2.default, null);
	      }
	      if (rawIcon == '/assets/ransom.svg') {
	        return _react2.default.createElement(_ransom2.default, null);
	      }
	    }
	    return _react2.default.createElement(
	      'li',
	      { key: item.node.id },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/solutions' + item.node.childMarkdownRemark.fields.slug },
	        theIcon(item),
	        _react2.default.createElement(
	          'h2',
	          { className: _IconGridModule2.default.itemHeading },
	          item.node.childMarkdownRemark.frontmatter.title
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _IconGridModule2.default.wrapper },
	    _react2.default.createElement(
	      _Inner2.default,
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: _IconGridModule2.default.heading },
	        props.heading
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: _IconGridModule2.default.items },
	        icons
	      )
	    )
	  );
	};
	
	exports.default = IconGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp":"(min-width: 700px)","darkGradient":"radial-gradient(#002A3B 0%, #00171F 94.96%)","dark":"#00171F","black":"#000000","tblue":"undefined","gray":"#EFEFEF","blue":"#00A8E8","wrapper":"src-components-IconGrid----IconGrid-module---wrapper---2T1A6","heading":"src-components-IconGrid----IconGrid-module---heading---1Y62o","itemHeading":"src-components-IconGrid----IconGrid-module---itemHeading---HmDmd","items":"src-components-IconGrid----IconGrid-module---items---Cr34w"};

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTypist = __webpack_require__(250);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	var _Button = __webpack_require__(70);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Divider = __webpack_require__(47);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _reactSizes = __webpack_require__(820);
	
	var _reactSizes2 = _interopRequireDefault(_reactSizes);
	
	var _reactAccessibleAccordion = __webpack_require__(732);
	
	var _IntroModule = __webpack_require__(628);
	
	var _IntroModule2 = _interopRequireDefault(_IntroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Intro = function Intro(props) {
	  function createBackground() {
	    if (!props.isMobile) {
	      return _react2.default.createElement(
	        'div',
	        { className: _IntroModule2.default.videoWrapper },
	        _react2.default.createElement(
	          'video',
	          { id: 'background-video', preload: 'none', loop: true, muted: true, autoPlay: true },
	          _react2.default.createElement('source', { src: '/domsysbg.mp4', type: 'video/mp4' }),
	          'Your browser does not support the video tag.'
	        )
	      );
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _IntroModule2.default.wrapper },
	    _react2.default.createElement('div', { className: _IntroModule2.default.overlay }),
	    createBackground(),
	    _react2.default.createElement('div', { className: _IntroModule2.default.gradientDivider }),
	    _react2.default.createElement(
	      'div',
	      { className: _IntroModule2.default.intro },
	      _react2.default.createElement(
	        'div',
	        { className: _IntroModule2.default.text },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            _reactTypist2.default,
	            null,
	            _react2.default.createElement(_reactTypist2.default.Delay, { ms: 500 }),
	            props.heading
	          )
	        ),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(
	          'p',
	          null,
	          props.body
	        ),
	        _react2.default.createElement(_Button2.default, { title: 'Learn More', link: '/about/' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _IntroModule2.default.solutions },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Qualifications'
	        ),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(
	          _reactAccessibleAccordion.Accordion,
	          null,
	          props.qualifications.map(function (item) {
	            return _react2.default.createElement(
	              _reactAccessibleAccordion.AccordionItem,
	              { key: item.qualification },
	              _react2.default.createElement(
	                _reactAccessibleAccordion.AccordionItemTitle,
	                null,
	                item.qualification
	              ),
	              _react2.default.createElement(
	                _reactAccessibleAccordion.AccordionItemBody,
	                null,
	                item.notes
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var mapSizesToProps = function mapSizesToProps(_ref) {
	  var width = _ref.width;
	  return {
	    isMobile: width < 700
	  };
	};
	
	exports.default = (0, _reactSizes2.default)(mapSizesToProps)(Intro);
	module.exports = exports['default'];

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp":"(min-width: 700px)","green":"#99C24D","tblue":"undefined","wrapper":"src-components-Intro----Intro-module---wrapper---2Y7Kk","gradientDivider":"src-components-Intro----Intro-module---gradientDivider---OE9b_","videoWrapper":"src-components-Intro----Intro-module---videoWrapper---3f7GC","overlay":"src-components-Intro----Intro-module---overlay---a81Up","intro":"src-components-Intro----Intro-module---intro---2TcdE","text":"src-components-Intro----Intro-module---text---1IySm","Cursor":"src-components-Intro----Intro-module---Cursor---2KZpZ","solutions":"src-components-Intro----Intro-module---solutions---10sld"};

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LogoGridModule = __webpack_require__(207);
	
	var _LogoGridModule2 = _interopRequireDefault(_LogoGridModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogoGrid = function LogoGrid(props) {
	  var listItems = props.items.map(function (item) {
	    return _react2.default.createElement(
	      'li',
	      { key: item.node.id },
	      _react2.default.createElement('img', { src: item.node.childMarkdownRemark.frontmatter.logo })
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'partners', className: _LogoGridModule2.default.wrapper },
	    _react2.default.createElement(
	      'ul',
	      { className: _LogoGridModule2.default.logoList },
	      listItems
	    )
	  );
	};
	
	exports.default = LogoGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp":"(min-width: 700px)","black":"#000000","darkGradient":"radial-gradient(#002A3B 0%, #00171F 94.96%)","wrapper":"src-components-LogoGrid----LogoGrid-module---wrapper---3ZTiD","logoList":"src-components-LogoGrid----LogoGrid-module---logoList---s1dJO"};

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(152);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _nukaCarousel = __webpack_require__(143);
	
	var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);
	
	var _TestimonialModule = __webpack_require__(208);
	
	var _TestimonialModule2 = _interopRequireDefault(_TestimonialModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonial = function Testimonial(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _TestimonialModule2.default.testimonial },
	    _react2.default.createElement(
	      'div',
	      { className: _TestimonialModule2.default.inner },
	      _react2.default.createElement(
	        'div',
	        { className: _TestimonialModule2.default.photo },
	        _react2.default.createElement(_Avatar2.default, { photo: props.photo })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _TestimonialModule2.default.body },
	        _react2.default.createElement(
	          'p',
	          null,
	          props.body
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _TestimonialModule2.default.meta },
	          '- ',
	          props.name,
	          ', ',
	          props.company
	        )
	      )
	    )
	  );
	};
	
	exports.default = Testimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"white":"#FFFFFF","bp":"(min-width: 700px)","testimonial":"src-components-Testimonial----Testimonial-module---testimonial---kPvJk","inner":"src-components-Testimonial----Testimonial-module---inner---HlTaR","photo":"src-components-Testimonial----Testimonial-module---photo---quwwb","body":"src-components-Testimonial----Testimonial-module---body---1pa8N","meta":"src-components-Testimonial----Testimonial-module---meta---1gCez"};

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Intro = __webpack_require__(357);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _LogoGrid = __webpack_require__(156);
	
	var _LogoGrid2 = _interopRequireDefault(_LogoGrid);
	
	var _IconGrid = __webpack_require__(154);
	
	var _IconGrid2 = _interopRequireDefault(_IconGrid);
	
	var _Testimonial = __webpack_require__(157);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	var _Button = __webpack_require__(70);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _indexModule = __webpack_require__(641);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  var introText = props.data.homeText.edges[0].node.childMarkdownRemark.frontmatter;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('script', { src: 'https://identity.netlify.com/v1/netlify-identity-widget.js' })
	    ),
	    _react2.default.createElement(_Intro2.default, {
	      heading: introText.intro_heading,
	      body: introText.intro_copy,
	      qualifications: introText.qualifications
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.dell },
	      _react2.default.createElement('img', {
	        src: '/assets/dell-technologies-logo.svg',
	        alt: 'Dell Silver Partner'
	      }),
	      'Authorized Partner'
	    ),
	    _react2.default.createElement(_IconGrid2.default, {
	      heading: 'Our Solutions',
	      subheading: 'Some subheading here.',
	      items: props.data.solutions.edges
	    })
	  );
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dell":"src-pages----index-module---dell---3AVOK"};

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"blue":"#00A8E8","dark":"#00171F","darkTo":"#002A3B","darkBlue":"#065679","white":"#FFFFFF","black":"#000000","green":"#99C24D","orange":"#F18F01","gray":"#EFEFEF","darkGradient":"radial-gradient(#002A3B 0%, #00171F 94.96%)","bp":"(min-width: 700px)"};

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Audit(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M208 132h288c8.8 0 16-7.2 16-16V76c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zM64 368c-26.5 0-48.6 21.5-48.6 48s22.1 48 48.6 48 48-21.5 48-48-21.5-48-48-48zm92.5-299l-72.2 72.2-15.6 15.6c-4.7 4.7-12.9 4.7-17.6 0L3.5 109.4c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.3c4.7-4.7 12.3-4.7 17 0l17 16.5c4.6 4.7 4.6 12.3-.1 17zm0 159.6l-72.2 72.2-15.7 15.7c-4.7 4.7-12.9 4.7-17.6 0L3.5 269c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.7c4.7-4.7 12.3-4.7 17 0l17 17c4.6 4.6 4.6 12.2-.1 16.9z" }));
	}
	
	Audit.defaultProps = { "viewBox": "0 0 512 512" };
	
	module.exports = Audit;
	
	Audit.default = Audit;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Backup(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z" }));
	}
	
	Backup.defaultProps = { "viewBox": "0 0 512 512" };
	
	module.exports = Backup;
	
	Backup.default = Backup;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Consolidation(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M440.935 12.574l3.966 82.766C399.416 41.904 331.674 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h49.084c5.57 0 10.377-3.842 11.676-9.259C103.407 137.408 172.931 80 256 80c60.893 0 114.512 30.856 146.104 77.801l-101.53-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12h-47.411c-6.853 0-12.315 5.729-11.987 12.574zM256 432c-60.895 0-114.517-30.858-146.109-77.805l101.868 4.871c6.845.327 12.573-5.134 12.573-11.986v-47.412c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12V500c0 6.627 5.373 12 12 12h47.385c6.863 0 12.328-5.745 11.985-12.599l-4.129-82.575C112.725 470.166 180.405 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176h-49.084c-5.57 0-10.377 3.842-11.676 9.259C408.593 374.592 339.069 432 256 432z" }));
	}
	
	Consolidation.defaultProps = { "viewBox": "0 0 512.333 512" };
	
	module.exports = Consolidation;
	
	Consolidation.default = Consolidation;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Consulting(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z" }));
	}
	
	Consulting.defaultProps = { "viewBox": "0 0 384 512" };
	
	module.exports = Consulting;
	
	Consulting.default = Consulting;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "clipPath": "url(#clip0_472_658)", "key": 0 }, [React.createElement("path", { "d": "M262.942 39.7605L268.654 33.5968C275.79 25.9087 275.79 13.4542 268.654 5.76603C261.519 -1.92201 249.959 -1.92201 242.823 5.76603L206.289 45.129C199.154 52.8171 199.154 65.2716 206.289 72.9598L242.823 112.323C246.395 116.167 251.068 118.091 255.741 118.091C260.414 118.091 265.086 116.167 268.654 112.323C275.79 104.635 275.79 92.1802 268.654 84.492L264.153 79.6419C300.45 84.2065 328.809 117.142 328.809 157.455C328.809 200.872 296.037 236.181 255.74 236.181C215.45 236.181 182.672 200.872 182.672 157.455C182.672 146.577 174.493 137.773 164.405 137.773C154.317 137.773 146.138 146.577 146.138 157.455C146.138 222.575 195.3 275.544 255.74 275.544C316.18 275.544 365.343 222.575 365.343 157.455C365.343 94.9575 320.017 43.7856 262.941 39.7593L262.942 39.7605Z", "fill": "black", "key": 0 }), React.createElement("path", { "d": "M493.211 393.632H0V472.376C0 494.078 16.3871 511.721 36.5258 511.721H474.957C495.095 511.721 511.482 494.077 511.482 472.376V393.632H493.211ZM73.6111 472.358C63.5234 472.358 55.2543 463.554 55.2543 452.676C55.2543 441.799 63.344 432.995 73.4316 432.995H73.611C83.7068 432.995 91.878 441.799 91.878 452.676C91.878 463.554 83.7069 472.358 73.6111 472.358ZM182.671 472.358H127.87C117.782 472.358 109.602 463.554 109.602 452.676C109.602 441.799 117.782 432.995 127.87 432.995H182.671C192.758 432.995 200.938 441.799 200.938 452.676C200.938 463.554 192.758 472.358 182.671 472.358Z", "fill": "black", "key": 1 }), React.createElement("path", { "d": "M436.468 227.373C433.378 220.709 427.049 216.496 420.13 216.496H371.087C350.512 262.958 306.606 295.222 255.733 295.222C204.854 295.222 160.956 262.958 140.379 216.496H91.3312C84.4117 216.496 78.0839 220.709 74.9889 227.378L6.96863 373.943H504.501L436.468 227.373Z", "fill": "black", "key": 2 })]), React.createElement("defs", { "key": 1 }, React.createElement("clipPath", { "id": "clip0_472_658" }, React.createElement("rect", { "width": "512", "height": "512", "fill": "white" })))]);
	}
	
	Workstations.defaultProps = { "width": "512", "height": "512", "viewBox": "0 0 512 512", "fill": "none" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Disaster(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z" }));
	}
	
	Disaster.defaultProps = { "viewBox": "0 0 448 512" };
	
	module.exports = Disaster;
	
	Disaster.default = Disaster;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Firewall(props) {
	    return React.createElement("svg", props, [React.createElement("rect", { "id": "Artboard1", "x": "0", "y": "0", "width": "60.775", "height": "46.3", "style": { "fill": "none" }, "key": 0 }), React.createElement("clipPath", { "id": "_clip1", "key": 1 }, React.createElement("rect", { "x": "0", "y": "0", "width": "60.775", "height": "46.3" })), React.createElement("g", { "clipPath": "url(#_clip1)", "key": 2 }, React.createElement("g", null, [React.createElement("g", { "key": 0 }, [React.createElement("path", { "d": "M7,47.2c-1.8,0 -3.5,0 -5.3,0c-0.8,0 -1.1,-0.4 -1.1,-1.5c0,-1.2 0,-2.4 0,-3.6c0,-1.1 0.3,-1.5 1.1,-1.5c3.5,0 7.1,0 10.6,0c0.8,0 1.1,0.4 1.1,1.5c0,1.2 0,2.4 0,3.6c0,1 -0.3,1.5 -1.1,1.5c-1.7,0 -3.5,0 -5.3,0Z", "style": { "fillRule": "nonzero" }, "key": 0 }), React.createElement("path", { "d": "M31.4,47.2l-14.1,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.5 1.6,-1.5c2.7,0 5.4,0 8.1,0c1.3,2.4 3.1,4.6 5.1,6c0.1,0.3 0.4,0.5 0.8,0.7Z", "style": { "fillRule": "nonzero" }, "key": 1 }), React.createElement("path", { "d": "M24.1,37.9l-1.8,0c-1.3,0 -1.7,-0.4 -1.7,-1.7c0,-1.2 0,-2.3 0,-3.5c0,-0.9 0.4,-1.4 1.4,-1.4l0.7,0c0,0.3 0,0.6 0,0.9c0.2,1.9 0.7,3.9 1.4,5.7Z", "style": { "fillRule": "nonzero" }, "key": 2 }), React.createElement("path", { "d": "M9.3,37.9c-2.4,0 -4.8,0 -7.1,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.4 1.6,-1.5l14.3,0c1,0 1.5,0.4 1.5,1.5c0,1.2 0,2.5 0,3.7c0,1 -0.4,1.4 -1.4,1.4c-2.6,0.1 -5,0.1 -7.4,0.1Z", "style": { "fillRule": "nonzero" }, "key": 3 }), React.createElement("path", { "d": "M7,28.7c-1.8,0 -3.5,0 -5.3,0c-0.8,0 -1.1,-0.4 -1.1,-1.5c0,-1.2 0,-2.4 0,-3.6c0,-1.1 0.3,-1.5 1.1,-1.5c3.5,0 7.1,0 10.6,0c0.8,0 1.1,0.4 1.1,1.5c0,1.2 0,2.4 0,3.6c0,1 -0.3,1.5 -1.1,1.5c-1.7,0 -3.5,0 -5.3,0Z", "style": { "fillRule": "nonzero" }, "key": 4 }), React.createElement("path", { "d": "M24.4,22.1c-0.9,2.3 -1.4,4.5 -1.6,6.6c-1.9,0 -3.7,0 -5.6,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.5 1.6,-1.5c2.3,0.1 4.7,0.1 7.1,0.1Z", "style": { "fillRule": "nonzero" }, "key": 5 }), React.createElement("path", { "d": "M29.1,12.9c-0.5,1 -1.1,2.1 -1.7,3.1c-0.6,1 -1.2,2 -1.7,3c-0.1,0.1 -0.1,0.3 -0.2,0.4l-3.2,0c-1.3,0 -1.7,-0.4 -1.7,-1.7c0,-1.2 0,-2.3 0,-3.5c0,-0.9 0.4,-1.4 1.4,-1.4c2.4,0.1 4.7,0.1 7.1,0.1Z", "style": { "fillRule": "nonzero" }, "key": 6 }), React.createElement("path", { "d": "M9.3,19.5c-2.4,0 -4.8,0 -7.1,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.4 1.6,-1.5l14.3,0c1,0 1.5,0.4 1.5,1.5c0,1.2 0,2.5 0,3.7c0,1 -0.4,1.4 -1.4,1.4c-2.6,0.1 -5,0.1 -7.4,0.1Z", "style": { "fillRule": "nonzero" }, "key": 7 })]), React.createElement("path", { "d": "M61,27.1c-0.1,-0.4 -0.2,-0.9 -0.2,-1.3c-1.3,-6.6 -5,-12.6 -6.8,-19.1c-1.6,2.1 -2.4,4.7 -2.4,7.3c0,1.1 0.1,2.4 -0.7,3.1c-4.1,4 -9.2,-12.8 -8,-16c0,-0.1 0,-0.2 0.1,-0.2c-4.7,2.5 -6.4,8.2 -5.6,13.2c0.4,2.5 0.1,4.9 -0.2,7.4c0,0.1 0,0.2 0,0.2c0,0.2 0,0.5 -0.1,0.7c0,0.1 -0.1,0.2 -0.1,0.3l0.1,0c-0.1,0.5 -0.2,1 -0.4,1.4c0,0 -0.1,0.1 -0.1,0.2c-0.1,0.3 -0.3,0.6 -0.5,0.9l-0.1,0.1c0,0.1 -0.1,0.1 -0.1,0.1c-0.2,0.3 -0.3,0.5 -0.6,0.7c0,0 -0.1,0.1 -0.2,0.1c-2.1,0.7 -1,-3.9 -0.8,-4.8c0.2,-1.4 0.4,-2.8 0.5,-4.3c0,-0.7 0.1,-1.5 0,-2.2c-0.1,-2.5 -2.4,-5.7 -2.4,-5.1c-0.1,3.6 -2.7,6.9 -4.2,10c-1.8,3.7 -3.3,8.2 -3,12.3c0.3,4.5 2.9,9.8 6.6,12.5c1.2,0.8 2.4,1.5 3.8,2.1c0.1,0 0.2,0.1 0.2,0.1l0.2,0c-1.4,-1.3 -1.3,-4.2 -1.3,-5.8c0.1,-3.1 1,-6.3 3,-8.8c1.3,-1.6 3.1,-3 4.7,-4.4c0.5,-0.4 0.9,-0.9 1.3,-1.3c0.1,-0.1 0.1,-0.1 0.2,-0.2c1.2,-1.4 2.2,-2.9 2.7,-5.1c0.1,-0.7 1.9,3.3 1.5,6.1c-0.4,2.5 -1.2,4.7 -2,6.9c-0.3,0.9 -2.5,5.7 -0.1,5.3c0.4,-0.1 0.8,-0.4 1.1,-0.7c0.8,-0.8 1.4,-1.8 1.8,-2.9c0.4,-1 1.7,-1.3 2.4,-0.5c0.1,0.2 0.3,0.3 0.4,0.5c0.8,1 1.3,2.2 1.6,3.4c0.4,1.5 0.4,3 0,4.5c-0.2,0.7 -0.4,1.4 -0.7,2c0.4,-0.2 0.8,-0.4 1.2,-0.6c0.3,-0.2 0.6,-0.3 0.9,-0.5c6.3,-3.7 7.4,-10.8 6.3,-17.6Z", "style": { "fillRule": "nonzero" }, "key": 1 })]))]);
	}
	
	Firewall.defaultProps = { "width": "100%", "height": "100%", "viewBox": "0 0 61 47", "version": "1.1", "xmlSpace": "preserve", "style": { "fillRule": "evenodd", "clipRule": "evenodd", "strokeLinejoin": "round", "strokeMiterlimit": "1.41421" } };
	
	module.exports = Firewall;
	
	Firewall.default = Firewall;

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Globe(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z" }));
	}
	
	Globe.defaultProps = { "viewBox": "0 0 496 512" };
	
	module.exports = Globe;
	
	Globe.default = Globe;

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Handshake(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z" }));
	}
	
	Handshake.defaultProps = { "viewBox": "0 0 640 512" };
	
	module.exports = Handshake;
	
	Handshake.default = Handshake;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Networking(props) {
	    return React.createElement("svg", props, [React.createElement("rect", { "id": "Artboard1", "x": "0", "y": "0", "width": "80", "height": "68", "style": { "fill": "none" }, "key": 0 }), React.createElement("g", { "key": 1 }, [React.createElement("rect", { "x": "30", "y": "54", "width": "20", "height": "14", "key": 0 }), React.createElement("rect", { "x": "30", "y": "0", "width": "20", "height": "14", "key": 1 }), React.createElement("rect", { "x": "0", "y": "54", "width": "20", "height": "14", "key": 2 }), React.createElement("rect", { "x": "60", "y": "54", "width": "20", "height": "14", "key": 3 }), React.createElement("path", { "d": "M42,32l0,-14l-4,0l0,14l-30,0l0,18l4,0l0,-14l26,0l0,14l4,0l0,-14l26,0l0,14l4,0l0,-18l-30,0Z", "style": { "fillRule": "nonzero" }, "key": 4 })])]);
	}
	
	Networking.defaultProps = { "width": "100%", "height": "100%", "viewBox": "0 0 80 68", "version": "1.1", "xmlSpace": "preserve", "style": { "fillRule": "evenodd", "clipRule": "evenodd", "strokeLinejoin": "round", "strokeMiterlimit": "1.41421" } };
	
	module.exports = Networking;
	
	Networking.default = Networking;

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "clipPath": "url(#clip0_571_695)", "key": 0 }, [React.createElement("path", { "d": "M668.738 486.827C664.259 479.358 657.54 474.879 650.072 474.879H623.936V137.385C623.936 112 603.029 91.8387 578.389 91.8387H502.977C470.868 36.588 408.898 0 337.217 0C265.536 0 203.564 37.3333 171.457 91.8387H96.045C70.6597 91.8387 50.4983 112.745 50.4983 137.385V474.879H23.6183C16.1495 474.879 9.43033 479.358 4.95166 486.827C-1.02234 497.28 -2.51715 514.452 5.69644 527.895C5.69644 528.639 6.44123 529.389 7.19124 529.389C55.7219 580.911 58.7126 580.911 63.9366 580.911H610.497C615.726 580.911 617.965 580.911 667.242 529.389L668.737 527.895C676.2 514.452 674.711 497.28 668.737 486.827H668.738ZM337.218 20.9065C429.806 20.9065 505.965 91.0945 505.965 177.707C505.965 238.936 467.137 294.936 407.402 320.32C394.71 325.549 386.496 338.241 386.496 351.68V379.305C386.496 381.545 385.001 383.04 382.761 383.04H367.829L367.834 335.253C367.834 329.279 363.355 324.8 357.381 324.8C351.407 324.8 346.928 329.279 346.928 335.253V383.04H328.262V335.253C328.262 329.279 323.782 324.8 317.809 324.8C311.835 324.8 307.356 329.279 307.356 335.253V383.04H292.424C290.184 383.04 288.689 381.545 288.689 379.305V351.68C288.689 337.492 280.476 325.544 267.782 320.32C208.048 294.935 169.22 238.935 169.22 177.707C168.475 91.0919 244.632 20.9065 337.22 20.9065H337.218ZM71.405 137.385C71.405 123.948 82.6029 112.745 96.045 112.745H161.004C152.79 132.907 148.311 154.557 148.311 177.704C148.311 247.141 192.363 310.611 259.566 339.731C264.795 341.97 267.779 346.449 267.779 351.678V379.304C267.779 392.741 278.977 403.944 292.419 403.944H383.513C396.95 403.944 408.153 392.746 408.153 379.304V351.678C408.153 346.449 411.137 341.225 416.366 339.731C484.314 310.611 527.621 247.143 527.621 177.704C527.621 154.559 523.142 132.901 514.928 112.745H579.887C593.324 112.745 604.527 123.943 604.527 137.385V474.879H71.4069L71.405 137.385ZM396.952 495.785V505.494C396.952 512.212 391.722 517.441 385.004 517.441L288.686 517.436C281.968 517.436 276.739 512.207 276.739 505.488V495.78L396.952 495.785ZM650.818 515.947C633.646 534.613 614.23 554.775 607.512 559.999H66.925C60.2062 554.025 40.789 533.863 23.6183 515.947C19.8839 509.228 22.1235 498.775 24.3631 495.785H255.83V505.494C255.83 523.415 270.762 538.348 288.684 538.348H385.002C402.923 538.348 417.856 523.416 417.856 505.494V495.785H649.323C652.308 498.77 654.547 508.478 650.813 515.947H650.818Z", "fill": "black", "key": 0 }), React.createElement("path", { "d": "M220.738 142.613C218.499 140.374 216.259 139.629 213.269 139.629C210.285 139.629 208.04 140.374 205.801 142.613C192.363 156.051 184.894 173.973 184.894 193.384C184.894 212.796 192.363 230.717 205.801 244.155C219.989 258.343 237.905 265.061 256.571 265.061C275.238 265.061 293.159 258.343 307.342 244.155C311.821 239.675 311.821 233.702 307.342 229.223L220.738 142.613ZM256.577 243.411C243.14 243.411 230.441 238.181 220.738 228.479C211.03 218.77 205.806 206.077 205.806 192.64C205.806 182.932 208.791 173.228 214.02 165.015L283.457 234.452C275.988 240.426 266.285 243.411 256.577 243.411Z", "fill": "black", "key": 1 }), React.createElement("path", { "d": "M461.165 139.627C458.181 139.627 455.936 140.371 453.696 142.611L367.082 228.48C363.347 232.215 363.347 239.678 367.082 243.412C381.27 257.6 399.186 264.319 417.852 264.319C436.519 264.319 454.44 257.6 468.623 243.412C496.248 215.787 496.248 170.24 468.623 142.61C466.389 140.375 463.404 139.625 461.164 139.625L461.165 139.627ZM390.233 235.2L459.67 165.763C472.363 185.175 470.123 211.309 452.952 228.481C436.525 245.653 410.389 247.893 390.233 235.2Z", "fill": "black", "key": 2 }), React.createElement("path", { "d": "M296.898 100.8C296.898 123.945 314.82 143.363 337.216 143.363C347.669 143.363 356.628 153.071 356.628 164.269C356.628 176.217 347.669 185.176 337.216 185.176C326.762 185.176 317.804 175.468 317.804 164.269C317.804 158.295 313.324 153.816 307.351 153.816C301.377 153.816 296.898 158.295 296.898 164.269C296.898 183.681 309.59 200.108 326.762 205.337V207.577C326.762 213.551 331.241 218.03 337.215 218.03C343.188 218.03 347.668 213.551 347.668 207.577V205.337C364.84 200.858 377.532 183.687 377.532 164.269C377.532 141.124 359.61 121.707 337.214 121.707C326.761 121.707 317.802 111.998 317.802 100.8C317.802 89.6021 326.761 79.8933 337.214 79.8933C347.668 79.8933 356.626 89.6016 356.626 100.8C356.626 106.774 361.106 111.253 367.079 111.253C373.053 111.253 377.532 106.774 377.532 100.8C377.532 81.388 364.84 64.9613 347.668 59.732V57.4924C347.668 51.5184 343.189 47.0393 337.215 47.0393C331.242 47.0393 326.762 51.5185 326.762 57.4924V59.732C309.59 64.2112 296.898 80.6386 296.898 100.8Z", "fill": "black", "key": 3 })]), React.createElement("defs", { "key": 1 }, React.createElement("clipPath", { "id": "clip0_571_695" }, React.createElement("rect", { "width": "674", "height": "581", "fill": "white" })))]);
	}
	
	Workstations.defaultProps = { "width": "674", "height": "581", "viewBox": "0 0 674 581", "fill": "none" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "clipPath": "url(#clip0_472_652)", "key": 0 }, [React.createElement("path", { "d": "M298.365 219.735C298.365 234.856 286.922 247.119 272.811 247.119C258.697 247.119 247.257 234.856 247.257 219.735C247.257 204.609 258.697 192.35 272.811 192.35C286.922 192.35 298.365 204.609 298.365 219.735Z", "fill": "black", "key": 0 }), React.createElement("path", { "d": "M128 55.4233C130.26 55.4233 132.424 54.4605 134.025 52.7489C135.622 51.0374 136.517 48.7146 136.517 46.2924V13.5586L97.4544 55.4233H128Z", "fill": "black", "key": 1 }), React.createElement("path", { "d": "M272.811 64.5503C259.26 64.5656 246.266 70.3383 236.686 80.6076C227.103 90.877 221.713 104.798 221.702 119.32V137.578H323.92V119.32C323.906 104.798 318.515 90.877 308.936 80.6076C299.353 70.3383 286.362 64.5659 272.811 64.5503Z", "fill": "black", "key": 2 }), React.createElement("path", { "d": "M502.8 247.12H443.171V9.78042C443.171 7.35822 442.276 5.03921 440.679 3.32384C439.078 1.61228 436.914 0.65332 434.654 0.65332H153.556V46.2922C153.535 53.5511 150.836 60.504 146.048 65.6348C141.26 70.7656 134.772 73.6577 128.002 73.6768H85.4103V247.121H8.74716C4.04488 247.121 0.230255 251.205 0.230255 256.248C0.230255 261.291 4.04488 265.375 8.74716 265.375H85.4103V498.147C85.4103 505.711 91.1322 511.839 98.1875 511.839C105.246 511.839 110.965 505.711 110.965 498.147V265.375H153.556V498.147C153.556 505.711 159.278 511.839 166.334 511.839C173.389 511.839 179.111 505.711 179.111 498.147V265.375H221.703V498.147C221.703 505.711 227.421 511.839 234.48 511.839C241.535 511.839 247.257 505.711 247.257 498.147V265.375H281.328V498.147C281.328 505.711 287.05 511.839 294.105 511.839C301.161 511.839 306.883 505.711 306.883 498.147V265.375H349.474V498.147C349.474 505.711 355.193 511.839 362.252 511.839C369.307 511.839 375.029 505.711 375.029 498.147V265.375H417.621L417.617 498.147C417.617 505.711 423.339 511.839 430.394 511.839C437.453 511.839 443.172 505.711 443.172 498.147V265.375H502.801C507.503 265.375 511.318 261.291 511.318 256.248C511.318 251.205 507.503 247.121 502.801 247.121L502.8 247.12ZM306.625 247.12H238.993C233.328 239.276 230.244 229.649 230.219 219.735C230.219 203.429 238.337 188.361 251.513 180.208C264.693 172.052 280.928 172.052 294.105 180.208C307.282 188.361 315.399 203.429 315.399 219.735C315.374 229.649 312.29 239.276 306.625 247.12ZM375.028 247.12H357.99V174.092C357.976 169.255 356.179 164.621 352.985 161.197C349.794 157.778 345.47 155.849 340.952 155.834H204.665C200.152 155.849 195.828 157.778 192.633 161.197C189.442 164.621 187.642 169.255 187.628 174.092V247.12H170.594V174.092C170.594 164.407 174.184 155.12 180.573 148.274C186.962 141.428 195.628 137.58 204.665 137.58V119.322C204.665 93.232 217.652 69.1255 238.736 56.0785C259.821 43.0355 285.798 43.0355 306.883 56.0785C327.967 69.1255 340.954 93.232 340.954 119.322V137.58C349.991 137.58 358.658 141.427 365.046 148.274C371.438 155.12 375.029 164.407 375.029 174.092L375.028 247.12Z", "fill": "black", "key": 3 })]), React.createElement("defs", { "key": 1 }, React.createElement("clipPath", { "id": "clip0_472_652" }, React.createElement("rect", { "width": "512", "height": "512", "fill": "white" })))]);
	}
	
	Workstations.defaultProps = { "width": "512", "height": "512", "viewBox": "0 0 512 512", "fill": "none" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Server(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z" }));
	}
	
	Server.defaultProps = { "viewBox": "0 0 512 512" };
	
	module.exports = Server;
	
	Server.default = Server;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Virtualization(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M537.585 226.56C541.725 215.836 544 204.184 544 192c0-53.019-42.981-96-96-96-19.729 0-38.065 5.954-53.316 16.159C367.042 64.248 315.288 32 256 32c-88.366 0-160 71.634-160 160 0 2.728.07 5.439.204 8.133C40.171 219.845 0 273.227 0 336c0 79.529 64.471 144 144 144h368c70.692 0 128-57.308 128-128 0-61.93-43.983-113.586-102.415-125.44z" }));
	}
	
	Virtualization.defaultProps = { "viewBox": "0 0 640 512" };
	
	module.exports = Virtualization;
	
	Virtualization.default = Virtualization;

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z" }));
	}
	
	Workstations.defaultProps = { "viewBox": "0 0 576 512" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-51521074db36921cb1a2.js